<template>
  <f7-page :page-content="true">
    <f7-navbar :back-link="$t('atras')">
      <f7-nav-title v-if="id && !readonly" sliding>{{$t('inspecciones.inspeccion_form.editar_inspeccion')}}</f7-nav-title>
      <f7-nav-title v-else-if="id" sliding>{{$t('inspecciones.inspeccion_form.inspeccion')}} - {{inspeccion ? inspeccion.codigo : ''}}</f7-nav-title>
      <f7-nav-title v-else sliding>{{$t('inspecciones.inspeccion_form.nueva_inspeccion')}}</f7-nav-title>
      <f7-nav-right>
        <f7-button
          v-if="!readonly"
          fill
          icon-f7="floppy_disk"
          text="Guardar"
          class="display-flex"
          @click="$refs.rform.formData.addJustificantes=false;$refs.rform.saveItem();"
          key="btn-guardar-inspeccion"
          ></f7-button>
          <f7-button
          v-if="id && readonly" 
          v-roles="{route: $f7route.url, roles: ['INSPECTOR']}"
          fill
          icon-f7="moon_zzz"
          :text="$t('inspecciones.inspeccion_form.pendiente_partes')"
          class="display-flex"
          @click="estadoPendientePartes"
          key="btn-pdtepartes-inspeccion"
          ></f7-button>
          <f7-button
          v-if="readonly" 
          v-roles="{route: $f7route.url, roles: ['ADMINISTRATIVO', 'RESPONSABLE','INSPECTOR']}"
          fill
          icon-f7="pencil"
          :text="$t('common.editar')"
          class="display-flex"
          color="red accent-4"
          @click.prevent="readonly=false; inspeccionInicial = Object.assign({}, $refs.rform.formData);"
          key="btn-editar-inspeccion"
        ></f7-button>
      </f7-nav-right>
    </f7-navbar>
    <r-form
      ref="rform"
      v-slot="{rform}"
      :itemId="id"
      @save="onSave"
      :readonly="readonly"
      :dbAdapter="Inspeccion"
      :beforeSave="beforeSave"
      @loadItem="loadItem"
      :defaultData="{documentos: [],fotosConNombre: [],valoracionArreglos: {fotosConNombre:[]}}"
    >
      <!-- @loadItem="function(item) {inspeccion = item}" -->
      <f7-row class="padding-vertical-half padding-right display-flex flex-direction-row-reverse top-buttons">
        <f7-button
          v-roles="['ADMINISTRATIVO']"
          v-if="rform && rform.formData && rform.formData.cliente && rform.formData.cliente.procedimiento == 'PROCEDIMIENTO_2' && rform.formData.idInspeccionRelacionada" 
          fill
          icon-f7="document_check_fill"
          text="Ver Certificación Relacionada"
          class="col-25 medium-50 small-100"
          color="blue"
          :href="'/inspecciones/view/'+rform.formData.idInspeccionRelacionada+'/'"
        ></f7-button>
        <f7-button
          v-if="rform && rform.formData && rform.formData.cliente && comprobarConfiguracion('GARANTIA_MECANICA','true') && (['PENDIENTE_FACTURACION','FACTURADA'].indexOf(rform.formData.estado.estado) > -1)"
          v-roles="[ 'ADMINISTRATIVO']"
          class="col-100 medium-25"
          v-tooltip="$t('inspecciones.inspeccion_form.solicitarGarantia')"
          fill
          icon-f7="umbrella"
          color="purple"
          :text="$t('inspecciones.inspeccion_form.solicitarGarantia')"
          @click.prevent="popupSolicitarGarantiaOpened = true"
        ></f7-button>
        <template v-if="rform && rform.formData && rform.formData.estado && (rform.formData.estado.estado == 'PERITADO' || rform.formData.estado.estado == 'EN_TALLER')">
          <f7-button
            v-if="rform && rform.formData && rform.formData.cliente && comprobarConfiguracion('ORDEN_TALLER','true')"
            v-roles="['ADMINISTRATIVO','RESPONSABLE']"
            class="col-100 medium-20"
            v-tooltip="rform.formData.estado.estado == 'PERITADO' ? $t('inspecciones.inspeccion_form.enviarATaller') : $t('inspecciones.inspeccion_form.nuevaOrdenTaller')"
            fill
            icon-f7="wrench_fill"
            color="pink"
            style="background-color: #F8BBD0;color:black;"
            :text="rform.formData.estado.estado == 'PERITADO' ? $t('inspecciones.inspeccion_form.enviarATaller') : $t('inspecciones.inspeccion_form.nuevaOrdenTaller')"
            @click.prevent="enviarATaller()"
          ></f7-button>
        </template>
        <f7-button
          v-roles="['ADMINISTRATIVO', 'RESPONSABLE', 'TECNICO']"
          v-if="preparadoParaEstimar()"
          icon-f7="calendar" 
          color="orange"
          v-tooltip="'Estimar fecha'"
          @click="estimarFecha()"
          fill
          text="Estimar tarea"
          class="col-100 medium-25"
        ></f7-button>
        <f7-button
          v-roles="['ADMINISTRATIVO', 'RESPONSABLE', 'TECNICO']"
          v-if="preparadoParaFinalizarTareaTaller()" 
          icon-f7="arrowtriangle_right_fill" 
          color="orange"
          v-tooltip="'Terminar tarea'"
          @click="terminarTarea()"
          fill
          text="Terminar tarea"
          class="col-100 medium-25"
        ></f7-button>
        <f7-button
          v-roles="['ADMINISTRATIVO', 'RESPONSABLE', 'TECNICO']"
          v-if="preparadoParaFinalizarTareaTaller()"
          icon-f7="calendar" 
          color="orange"
          v-tooltip="'Modificar estimación'"
          @click="modificarFechaEstimada()"
          fill
          text="Modificar estimación"
          class="col-100 medium-25"
        ></f7-button>
        <f7-button
          v-roles="['ADMINISTRATIVO', 'RESPONSABLE']"
          v-if="preparadoParaControlCalidad()" 
          icon-f7="checkmark_alt_circle" 
          :color="colorControlCalidad()"
          v-tooltip="'Control Calidad'"
          @click="controlCalidad()"
          fill
          text="Control Calidad"
          class="col-100 medium-25"
        ></f7-button>
        <f7-button
          v-roles="['ADMIN']"
          v-if="rform && rform.formData && rform.formData.htmlControlCalidad" 
          icon-f7="checkmark_alt_circle" 
          :color="'yellow'"
          v-tooltip="'Borrar datos Control Calidad'"
          @click="borrarControlCalidad()"
          fill
          text="Borrar formulario Control Calidad"
        ></f7-button>
      </f7-row>
      <f7-card class="padding-vertical-half padding-right">
        <f7-row no-gap class="margin-left">
          <f7-col width="25">
            <!-- <f7-link
              v-if="rform.formData && rform.formData.pedido && rform.formData.pedido.id"
              v-roles="{route: $f7route.url, roles: ['ADMINISTRATIVO', 'CLIENTE']}"
              icon-f7="eye"
              text="Ver Cita"
              v-tooltip="'Ver Cita'"
              color="green"
              :href="'/pedidos/view/' + (rform.formData && rform.formData.pedido ? rform.formData.pedido.id : '') + '/'"
            ></f7-link> -->
            <!-- <f7-link
              v-if="rform.formData && rform.formData.pedido && rform.formData.pedido.id"
              v-roles="{route: $f7route.url, roles: ['ADMINISTRATIVO', 'INSPECTOR']}"
              icon-f7="eye"
              text="Marcar como peritado"
              v-tooltip="'Marcar como peritado'"
              color="green"
              @click.prevent="marcarPeritado()"
            ></f7-link> -->
          </f7-col>
        </f7-row>
        <f7-card-content>
          <f7-row no-gap class="list list-form no-hairlines">
            <f7-col width="100" medium="70">
              <ul>
                <f7-row no-gap>
                  <HistoricoEstados class="historicoEstados" :inspeccion="inspeccion"/>
                </f7-row>
                <!-- <f7-row no-gap>
                    <li class="readonly col-33" floating-label="" 
                      :label="$t('inspecciones.inspeccion_form.duracion')">
                      <div class="item-content item-input item-input-with-value">
                        <div class="item-inner">
                          <div class="item-title item-label item-floating-label">{{$t('inspecciones.inspeccion_form.duracion')}}</div>
                          <div class="item-input-wrap">
                            {{rform.formData.duracion * 60 || '-' | timeInHours}}
                          </div>
                        </div>
                      </div>
                    </li>
                    <r-input
                      v-roles="{route: $f7route.url, roles: ['ADMINISTRATIVO']}"
                      floating-label
                      class="col-33"
                      :label="$t('inspecciones.inspeccion_form.duracion_estimada')"
                      :form="rform"
                      type="text"
                      name="lineaPedido.horasEstimadas"
                      :readonly="true"
                      :overrideReadonly="true"
                    ></r-input>
                    <r-input
                      v-roles="{route: $f7route.url, roles: ['ADMINISTRATIVO']}"
                      floating-label
                      class="col-33"
                      :label="$t('inspecciones.inspeccion_form.importe')"
                      :form="rform"
                      type="text"
                      name="lineaPedido.importe"
                    ></r-input>
                </f7-row> -->
                <f7-row no-gap>
                  <r-input
                    outline
                      floating-label
                      class="col-100"
                      :label="$t('inspecciones.inspeccion_form.observaciones')"
                      :form="rform"
                      type="textarea"
                      name="lineaPedido.observaciones"
                    ></r-input>
                </f7-row>
              </ul>
            </f7-col>
            <f7-col width="100" medium="30">
              <ul>
                <f7-row no-gap>
                  <r-input
                    floating-label
                    :label="$t('inspecciones.inspeccion_form.matricula')"
                    :form="rform"
                    type="text"
                    :name="'lineaPedido.coche.matricula'"
                    @change="searchCoche"
                  ></r-input>
                  <r-input
                    floating-label
                    :label="$t('inspecciones.inspeccion_form.bastidor')"
                    :form="rform"
                    type="text"
                    :name="'lineaPedido.coche.bastidor'"
                    @change="searchCoche"
                  ></r-input>
                </f7-row>
              <f7-row media-list class="no-line">
                <!-- <f7-col width="100" medium="50">
                  <r-files 
                    :maxFiles="1"
                    :form="rform" 
                    :name="'lineaPedido.coche.modelo.imagen'" 
                  />
                </f7-col> -->
                <f7-col width="100" medium="50">
                  <r-autocomplete
                  :dbAdapter="Marca"
                  floating-label
                  :label="$t('inspecciones.inspeccion_form.marca')"
                  :form="rform"
                  :name="'lineaPedido.coche.modelo.marca'"
                  labelProp="nombre"
                  ></r-autocomplete>
                </f7-col>
                <f7-col width="100" medium="50">
                  <r-input
                    floating-label
                    :label="$t('pedidos.pedido_form.modelo')"
                    :form="rform"
                    type="text"
                    :name="'lineaPedido.coche.modelo.nombre'"
                  ></r-input>
                  <!-- <r-autocomplete
                    :dbAdapter="Modelo"
                    floating-label
                    :label="$t('inspecciones.inspeccion_form.modelo')"
                    :form="rform"
                    :name="'lineaPedido.coche.modelo'"
                    labelProp="nombre"
                  ></r-autocomplete> -->
                </f7-col>
                <f7-col width="100">
                    <r-autocomplete
                      v-roles="['ADMIN','ADMINISTRATIVO','RESPONSABLE']"
                      :dbAdapter="Inspector"
                      floating-label
                      :label="$t('inspecciones.inspeccion_form.inspector')"
                      :form="rform"
                      name="inspector.username"
                      labelProp="name"
                      :readonly="true"
                    ></r-autocomplete>
                    <r-input
                      v-roles="['INSPECTOR']"
                      floating-label
                      :label="$t('inspecciones.inspeccion_form.observaciones')"
                      :form="rform"
                      name="lineaPedido.observaciones"
                      :type="'text'"
                      :readonly="true"
                      :overrideReadonly="true"
                    ></r-input>
                  </f7-col>
              </f7-row>
              <f7-row>
                  <!-- <f7-link 
                    class="col-5"
                    style="display: inline-flex;"
                    v-if="rform && rform.formData && rform.formData.cliente && comprobarConfiguracion('ORDEN_TALLER','true)"
                    v-tooltip="$t('inspecciones.inspeccion_form.finalizar')"
                    icon-f7="checkmark_rectangle_fill"
                    color="orange"
                    fill 
                    @click="popupCambiaEstadoOpened = true"
                  ></f7-link> -->
                  <f7-col
                    width="100"
                    medium="50"
                  >
                    <r-input
                      class="badge-estado-coche badge-estado"
                      style="display: inline-flex;"
                      floating-label
                      :label="$t('inspecciones.inspeccion_form.estadoVehiculo')"
                      :form="rform"
                      type="badge"
                      :name="'lineaPedido.coche.estado.estado'"
                      :readonly="true"
                      :overrideReadonly="true"
                      :text="rform.formData.lineaPedido && rform.formData.lineaPedido.coche && rform.formData.lineaPedido.coche.estado ? getTextoBadgeEstadoVehiculo(-1): 'Sin estado'"
                      :color="rform.formData.lineaPedido && rform.formData.lineaPedido.coche && rform.formData.lineaPedido.coche.estado ? getColorBadgeEstadoVehiculo(getHistoricoEstados()[getHistoricoEstados().length - 1]): 'gray'"
                    ></r-input>
                  </f7-col>
                  <f7-col
                    width="100"
                    medium="50"
                  >
                    <f7-button
                      v-if="rform && rform.formData && rform.formData.cliente && readonly"
                      v-roles="{route: $f7route.url, roles: ['ADMINISTRATIVO','RESPONSABLE']}"
                      style="font-size: 14px; bottom: -15px;"
                      v-tooltip="$t('inspecciones.inspeccion_form.cambiarEstado')"
                      icon-f7="folder_badge_plus"
                      fill
                      color="orange"
                      text="Cambiar estado"
                      @click="forzarCambioEstado"
                    ></f7-button>
                  </f7-col>
              </f7-row> 
              <f7-row>
                <f7-col
                  width="100"
                  medium="50"
                >
                  <r-input
                    floating-label
                    :label="$t('pedidos.pedido_form.comercial')"
                    :form="rform"
                    type="text"
                    :name="'lineaPedido.comercial'"
                  ></r-input>
                </f7-col>
                <f7-col
                  width="100"
                  medium="50"
                >
                  <r-input
                    floating-label
                    :label="$t('pedidos.pedido_form.cliente')"
                    :form="rform"
                    type="text"
                    :name="'lineaPedido.cliente'"
                  ></r-input>
                </f7-col>
                <f7-col
                  width="100"
                  medium="50"
                >
                  <r-input
                    floating-label
                    :label="$t('pedidos.pedido_form.bps')"
                    :form="rform"
                    type="text"
                    :name="'lineaPedido.coche.camposPersonalizados.bps'"
                  ></r-input>
                </f7-col>
                <f7-col
                  width="100"
                  medium="50"
                >
                  <r-input
                    floating-label
                    :label="$t('pedidos.pedido_form.proxima_itv')"
                    :form="rform"
                    type="datepicker"
                    :name="'lineaPedido.coche.fechaProximaITV'"
                  ></r-input>
                </f7-col>
                <f7-col
                  width="100"
                  medium="50"
                >
                  <r-input
                    floating-label
                    :label="$t('pedidos.pedido_form.pasar_itv')"
                    :form="rform"
                    type="check"
                    :name="'lineaPedido.coche.tieneQuePasarITV'"
                  ></r-input>
                </f7-col>
                <f7-col
                  width="100"
                  medium="50"
                >
                  <r-input
                    floating-label
                    :label="'Fecha matriculación'"
                    :form="rform"
                    type="datepicker"
                    :name="'lineaPedido.coche.fechaMatriculacion'"
                    @change="updateCaracteristica('1A_MATRICULACION', rform.formData.lineaPedido.coche.fechaMatriculacion)"
                    :calendar-params="{closeOnSelect:true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit' } }"
                  ></r-input>
                </f7-col>
                <f7-col 
                  width="100"
                  medium="50"
                >
                  <r-input
                    floating-label
                    :label="'Origen 1'"
                    :form="rform"
                    type="text"
                    :name="'lineaPedido.coche.origen1'"
                  ></r-input>
                </f7-col>
                <f7-col width="100" medium="50" >
                  <r-input
                    floating-label
                    :label="'Origen 2'"
                    :form="rform"
                    type="text"
                    :name="'lineaPedido.coche.origen2'"
                  ></r-input>
                </f7-col>



                <f7-col class="col-100 medium-50" >
                  <r-input
                    floating-label
                    :label="'Ubicación'"
                    :form="rform"
                    type="select"
                    :name="'lineaPedido.coche.ubicacion'"
                    :clearButton="false"
                    class="UBICACION"
                  >
                    <option :value="null"></option>
                    <option v-for="(ubicacion, n) in ubicaciones"
                      :selected="ubicacion.nombre == rform.formData.lineaPedido.coche.ubicacion"
                      :key="'-ubicacion-'+n"
                      :value="ubicacion.nombre">{{ubicacion.nombre}}</option>
                  </r-input>
                </f7-col>
                <f7-col class="col-100 medium-50" >
                  <r-input
                    floating-label
                    :label="'Localización'"
                    :form="rform"
                    type="text"
                    :name="'lineaPedido.coche.localizacion'"
                    :clearButton="false"
                    class="OTRA"
                  >
                    <option selected disabled></option>
                    <option v-for="(localizacion, n) in localizaciones"
                      :key="'-localizacion-'+n"
                      :value="localizacion.nombre">{{localizacion.nombre}}</option>
                  </r-input>
                </f7-col>
                <f7-col class="col-100 medium-50" >
                  <r-input
                    floating-label
                    :label="'Taller'"
                    :form="rform"
                    type="select"
                    :name="'lineaPedido.coche.taller'"
                    :clearButton="false"
                    class="TALLER"
                  >
                    <option selected disabled></option>
                    <option v-for="(taller, n) in talleres"
                      :key="'-taller-'+n"
                      :value="taller.nombre">{{taller.nombre}}</option>
                  </r-input>
                </f7-col>

              </f7-row>
              <!-- <f7-row>
                <r-input
                  v-if="rform && rform.formData && rform.formData.lineaPedido && rform.formData.lineaPedido.coche"
                  type="text"
                  class="col-100"
                  :label="$t('inspecciones.inspeccion_form.ubicacion')"
                  :form="rform"
                  :name="'lineaPedido.coche.ubicacion'"
                  :readonly="readonly"
                ></r-input>
              </f7-row>  -->
              </ul>
            </f7-col>
            <!-- BMW: Comercial, cliente, BPS/Next KM, Proxima ITV (autocalculado), tiene que pasar (autocalculado),
                Factura chapa, importe chapa, factura mecanica, importe mecanica -->
          </f7-row>
        </f7-card-content>
      </f7-card>

      <div v-noroles="['VENTAS']">
        <div v-if="peritoVisible()">
          <!-- datos de la peritación -->
          <template v-if="permisosVer('valoracion')">
            <f7-block-title>
              PERITACIÓN
            </f7-block-title>
            <f7-card>
              <f7-card-content>
                <!-- v-noroles="['ADMINISTRATIVO','RESPONSABLE']" -->
                <f7-row no-gap class="list list-form no-hairlines">
                  <template>
                    <f7-col width="100" medium="50" >
                      <r-input
                        floating-label
                        :label="'Valoración carrocería'"
                        :form="rform"
                        type="number"
                        step="0.01"
                        :name="'valoracionArreglos.importeChapa'"
                        :readonly="true"
                        :overrideReadonly="true"
                      ></r-input>
                    </f7-col>
                    <f7-col width="100" medium="50" >
                      <r-input
                        floating-label
                        :label="'Valoración mecánica'"
                        :form="rform"
                        type="number"
                        step="0.01"
                        :name="'valoracionArreglos.importeMecanica'"
                        :readonly="true"
                        :overrideReadonly="true"
                      ></r-input>
                    </f7-col>
                    <f7-col width="0" medium="20">
                    </f7-col>
                  </template>
                  <template>
                    <f7-col width="100" medium="100">
                      <r-files
                        class="col-100"
                        style="border: 1px solid #7a7a95;border-radius: 5px;margin: 5px 15px;"
                        :form="rform"
                        :name="'valoracionArreglos.documentos'"
                        :label="'Documentación aportada por la inspección'"
                        :documentoAdapter="Documento"
                        :preview="false"
                        :readonly="true"
                        :overrideReadonly="true"
                      ></r-files>
                    </f7-col>
                    <f7-col width="100" medium="100">
                      <r-files
                        class="col-100"
                        style="border: 1px solid #7a7a95;border-radius: 5px;margin: 5px 15px;"
                        :form="rform"
                        :name="'valoracionArreglos.informes'"
                        :label="'Informes de reacondicionamiento'"
                        :documentoAdapter="Documento"
                        :preview="false"
                        :readonly="true"
                        :overrideReadonly="true"
                      ></r-files>
                    </f7-col>
                    <f7-col width="100" medium="100" >
                      <r-input
                        floating-label
                        outline
                        :label="'Observaciones'"
                        :form="rform"
                        type="textarea"
                        :name="'valoracionArreglos.observaciones'"
                        :readonly="true"
                        :overrideReadonly="true"
                      ></r-input>
                    </f7-col>
                  </template>
                  <template>
                    <!-- Fotos con nombre -->
                    <div class="fotos-con-nombre" style="width: 100%;" v-if="permisosVer('fotos')">
                      <f7-navbar class="navbar valoracion-arreglos">
                        <f7-block-title>
                          {{$t('inspecciones.inspeccion_form.valoracionArreglos.fotosConNombre')}}
                        </f7-block-title>
                      </f7-navbar>
                      
                      <f7-card class="elevation-3 padding-vertical-half padding-right">
                        <f7-card-content>
                          <f7-list 
                            v-for="(fotoConNombre,index) in rform.formData.valoracionArreglos.fotosConNombre" 
                            :key="'valoracionArreglos-fotosConNombre-'+index"
                            class="fotoconnombre"
                          >
                            <div >
                              <f7-row>
                                <r-files 
                                  :form="rform" 
                                  :name="'valoracionArreglos.fotosConNombre.'+index+'.documentos'" 
                                  :documentoAdapter="Documento" 
                                  :isObject="false"
                                  :readonly="true"
                                  :overrideReadonly="true"
                                >
                                  <template v-slot:topbar="{}">
                                    <!-- <f7-button 
                                      v-if="!readonly" 
                                      style="display:inline-block;aling:left;"
                                      slot="right" 
                                      color="primary"
                                      @click="capturarFotoConNombre(fotoConNombre, index)" 
                                      icon-f7="add_a_photo" 
                                      v-tooltip="'Capturar foto'"
                                    ></f7-button> -->
                                  </template>
                                </r-files>
                                <!-- <f7-button
                                  v-if="!rform.readonly && fotoConNombre.editable"
                                  small
                                  color="red"
                                  icon-f7="trash" 
                                  v-tooltip="'Eliminar'"
                                  @click="eliminarFotoConNombre(fotoConNombre, index, rform.formData.valoracionArreglos.fotosConNombre)"
                                ></f7-button> -->
                              </f7-row>
                              <f7-row>
                                <r-input
                                  class="col-85" 
                                  :form="rform"
                                  type="text"
                                  :name="'valoracionArreglos.fotosConNombre.'+index+'.nombre'"
                                  :_readonly="!fotoConNombre.editable"
                                  :readonly="true"
                                  :overrideReadonly="true"
                                ></r-input>
                                <r-input
                                  class="col-20"
                                  :form="rform"
                                  type="check"
                                  :simple="true"
                                  v-tooltip="fotoConNombre.visible?$t('inspecciones.inspeccion_form.visible'):$t('inspecciones.inspeccion_form.oculto')"
                                  :name="'valoracionArreglos.fotosConNombre.'+index+'.visible'"
                                  :key="'valoracionArreglos.fotosConNombre.'+index+'.visible'"
                                  :readonly="true"
                                  :overrideReadonly="true"
                                ></r-input>
                              </f7-row>

                            </div>
                          </f7-list>
                        </f7-card-content>
                      </f7-card>
                    </div>
                    <!-- Fin de fotos con nombre -->
                  </template>
                </f7-row>
      
                <f7-row 
                  v-roles="['ADMINISTRATIVO','RESPONSABLE','INSPECTOR']" 
                  v-if="rform.formData.estado && rform.formData.estado.estado && (rform.formData.estado.estado === 'PENDIENTE_ACEPTACION' || rform.formData.estado.estado === 'PENDIENTE_VALORACION')"
                  no-gap 
                  style="justify-content: center; margin-top: 20px;padding-bottom: 10px;"
                  class="list list-form no-hairlines"
                >
                  <template>
                    <f7-button
                      v-if="rform.formData.estado && rform.formData.estado.estado && rform.formData.estado.estado === 'PENDIENTE_ACEPTACION'"
                      v-roles="['ADMINISTRATIVO','RESPONSABLE']"
                      width="10" medium="10"
                      fill
                      icon-f7="money_euro_circle"
                      color="red"
                      text="Rechazar"
                      class="display-flex"
                      @click="rechazarValoracion"
                      :readonly="!readonly"
                      :overrideReadonly="true"
                    ></f7-button>
                    <f7-col width="0" medium="10">
                    </f7-col>
                    <f7-button
                      v-if="rform.formData.estado && rform.formData.estado.estado && rform.formData.estado.estado === 'PENDIENTE_ACEPTACION'"
                      v-roles="['ADMINISTRATIVO','RESPONSABLE']"
                      width="10" medium="10"
                      fill
                      icon-f7="money_euro_circle"
                      color="green"
                      text="Aceptar"
                      class="display-flex"
                      @click="aceptarValoracion"
                      :readonly="!readonly"
                      :overrideReadonly="true"
                    ></f7-button>
                    <f7-button
                      v-if="rform.formData.estado && rform.formData.estado.estado && rform.formData.estado.estado === 'PENDIENTE_VALORACION'"
                      v-roles="['ADMINISTRATIVO','RESPONSABLE','INSPECTOR']"
                      fill
                      v-tooltip="'Valorar arreglos'"
                      icon-f7="money_euro_circle"
                      color="blue"
                      text="Valorar"
                      class="display-flex"
                      @click="valorarArreglos"
                      :readonly="!readonly"
                      :overrideReadonly="true"
                    ></f7-button>
                  </template>
                </f7-row>
      
              </f7-card-content>
            </f7-card>
          </template>
          <!-- datos de la peritación -->

          

          <!-- Datos de control de calidad -->
          <template v-if="permisosVer('valoracion')">
            <f7-block-title>
              DOCUMENTACIÓN (CONTROL DE CALIDAD)
            </f7-block-title>
            <f7-card>
              <f7-card-content>
                <f7-card
                  v-roles="{route: $f7route.url, roles: ['ADMINISTRATIVO', 'RESPONSABLE']}"
                  class="elevation-3 padding-vertical-half padding-right"
                  style="z-index: 1002;"
                >
                  <f7-card-content>
                    {{$t('clientes.cliente_form.firmas')}}
                    <f7-row>
                      <f7-list class="col-15 list-form">
                        <r-autocomplete
                          :key="'firmaMecanico'"
                          class="padding-vertical"
                          style="z-index: 1001;"
                          floating-label
                          :label="$t('clientes.cliente_form.firmaMecanico')"
                          :form="rform"
                          :shownFields="['firma']"
                          ref="firmaMecanico"
                          :name="'firmas360.firmaMecanico'"
                          :dbItems="(rform.formData.firmas360 && rform.formData.firmas360.firmasDisponibles)?rform.formData.firmas360.firmasDisponibles:[]"
                          :idProp="'_id'"
                          labelProp="nombre"
                        ></r-autocomplete>
                      </f7-list>
                      <f7-list class="col-15 list-form">
                        <r-autocomplete
                          :key="'firmaTecnico'"
                          class="padding-vertical"
                          style="z-index: 1001;"
                          floating-label
                          :label="$t('clientes.cliente_form.firmaTecnico')"
                          :form="rform"
                          :shownFields="['firma']"
                          ref="firmaTecnico"
                          :name="'firmas360.firmaTecnico'"
                          :dbItems="(rform.formData.firmas360 && rform.formData.firmas360.firmasDisponibles)?rform.formData.firmas360.firmasDisponibles:[]"
                          :idProp="'_id'"
                          labelProp="nombre"
                        ></r-autocomplete>
                      </f7-list>
                      <f7-list class="col-15 list-form">
                        <r-autocomplete
                          :key="'firmaMaestroTaller'"
                          class="padding-vertical"
                          style="z-index: 1001;"
                          floating-label
                          :label="$t('clientes.cliente_form.firmaMaestroTaller')"
                          :form="rform"
                          :shownFields="['firma']"
                          ref="firmaMaestroTaller"
                          :name="'firmas360.firmaMaestroTaller'"
                          :dbItems="(rform.formData.firmas360 && rform.formData.firmas360.firmasDisponibles)?rform.formData.firmas360.firmasDisponibles:[]"
                          :idProp="'_id'"
                          labelProp="nombre"
                        ></r-autocomplete>
                      </f7-list>
                      <f7-list class="col-15 list-form">
                        <r-autocomplete
                          :key="'firmaResponsableVO'"
                          class="padding-vertical"
                          style="z-index: 1001;"
                          floating-label
                          :label="$t('clientes.cliente_form.firmaResponsableVO')"
                          :form="rform"
                          :shownFields="['firma']"
                          ref="firmaResponsableVO"
                          :name="'firmas360.firmaResponsableVO'"
                          :dbItems="(rform.formData.firmas360 && rform.formData.firmas360.firmasDisponibles)?rform.formData.firmas360.firmasDisponibles:[]"
                          :idProp="'_id'"
                          labelProp="nombre"
                        ></r-autocomplete>
                      </f7-list>
                      <f7-list class="col-15 list-form">
                        <r-autocomplete
                          :key="'firmaAsesorServicio'"
                          class="padding-vertical"
                          style="z-index: 1001;"
                          floating-label
                          :label="$t('clientes.cliente_form.firmaAsesorServicio')"
                          :form="rform"
                          :shownFields="['firma']"
                          ref="firmaAsesorServicio"
                          :name="'firmas360.firmaAsesorServicio'"
                          :dbItems="(rform.formData.firmas360 && rform.formData.firmas360.firmasDisponibles)?rform.formData.firmas360.firmasDisponibles:[]"
                          :idProp="'_id'"
                          labelProp="nombre"
                        ></r-autocomplete>
                      </f7-list>
                      <f7-list class="col-15 list-form">
                        <r-autocomplete
                          :key="'firmaResponsableVehiculosOcasion'"
                          class="padding-vertical"
                          style="z-index: 1001;"
                          floating-label
                          :label="$t('clientes.cliente_form.firmaResponsableVehiculosOcasion')"
                          :form="rform"
                          :shownFields="['firma']"
                          ref="firmaResponsableVehiculosOcasion"
                          :name="'firmas360.firmaResponsableVehiculosOcasion'"
                          :dbItems="(rform.formData.firmas360 && rform.formData.firmas360.firmasDisponibles)?rform.formData.firmas360.firmasDisponibles:[]"
                          :idProp="'_id'"
                          labelProp="nombre"
                        ></r-autocomplete>
                      </f7-list>
                    </f7-row>
                  </f7-card-content>
                </f7-card>

                <f7-card
                  v-roles="{route: $f7route.url, roles: ['ADMINISTRATIVO', 'RESPONSABLE']}"
                  class="elevation-3 padding-vertical-half padding-right"
                  style="z-index: 1001;"
                >
                  <f7-card-content>
                    <f7-block-title>
                      Informes de control de calidad <r-badge v-if="rform.formData&&rform.formData.controlCalidad&&rform.formData.controlCalidad.calificacion" :text="$t(rform.formData.controlCalidad.calificacion)" :color="getColorBadgeCalificacion(rform.formData.controlCalidad.calificacion)"></r-badge>
                      <f7-link
                        @click="popupHistoricoControlCalidadOpened = true"
                        icon-f7="square_favorites_fill"
                        color="blue"
                      ></f7-link>
                    </f7-block-title>
                    <f7-row>
                      <r-files
                        class="col-100 little-image"
                        floating-label
                        outline
                        :label="'INFORMES DE CONTROL DE CALIDAD'"
                        :form="rform"
                        :name="'controlCalidad.informes'"
                        :documentoAdapter="Documento"
                        :preview="false"
                        :readonly="rform.readonly || (rform.formData.estado && rform.formData.estado.estado !== 'CONTROL_FINAL')"
                        :overrideReadonly="true"
                      ></r-files>
                    </f7-row>
                    <f7-row>
                      <!-- Fotos con nombre -->
                      <div class="fotos-con-nombre" style="width: 100%;" v-if="(rform.formData.controlCalidad && rform.formData.controlCalidad.fotosConNombre && rform.formData.controlCalidad.fotosConNombre.length > 0 || !rform.readonly) && permisosVer('fotos')">
                        <f7-navbar class="navbar valoracion-arreglos">
                          <f7-block-title>
                            {{$t('inspecciones.inspeccion_form.controlCalidad.fotosConNombre')}}
                          </f7-block-title>
                        </f7-navbar>
                        
                        <f7-card class="elevation-3 padding-vertical-half padding-right">
                          <f7-card-content>
                            <f7-list 
                              v-for="(fotoConNombre,index) in rform.formData.controlCalidad.fotosConNombre" 
                              :key="'controlCalidad-fotosConNombre-'+index"
                              class="fotoconnombre"
                            >
                              <div >
                                <f7-row>
                                  <r-files 
                                    :form="rform" 
                                    :name="'controlCalidad.fotosConNombre.'+index+'.documentos'"
                                    :documentoAdapter="Documento" 
                                    :isObject="false"
                                    :readonly="rform.readonly || (rform.formData.estado && rform.formData.estado.estado !== 'CONTROL_FINAL')"
                                    :overrideReadonly="true"
                                  >
                                    <template v-slot:topbar="{}">
                                    </template>
                                  </r-files>
                                </f7-row>
                                <f7-row>
                                  <r-input
                                    class="col-85" 
                                    :form="rform"
                                    type="text"
                                    :name="'controlCalidad.fotosConNombre.'+index+'.nombre'"
                                    :readonly="rform.readonly || !fotoConNombre.editable || (rform.formData.estado && rform.formData.estado.estado !== 'CONTROL_FINAL')"
                                    :overrideReadonly="true"
                                  ></r-input>
                                  <r-input
                                    class="col-20"
                                    :form="rform"
                                    type="check"
                                    :simple="true"
                                    v-tooltip="fotoConNombre.visible?$t('inspecciones.inspeccion_form.visible'):$t('inspecciones.inspeccion_form.oculto')"
                                    :name="'controlCalidad.fotosConNombre.'+index+'.visible'"
                                    :key="'controlCalidad.fotosConNombre.'+index+'.visible'"
                                    :readonly="rform.readonly || (rform.formData.estado && rform.formData.estado.estado !== 'CONTROL_FINAL')"
                                    :overrideReadonly="true"
                                  ></r-input>
                                </f7-row>

                              </div>
                            </f7-list>
                          </f7-card-content>
                        </f7-card>
                      </div>
                      <!-- Fin de fotos con nombre -->
                    </f7-row>
                    <f7-row>
                      <f7-col width="100" medium="100">
                        <f7-block-title>Justificantes y otra documentación</f7-block-title>
                        <r-files
                          class="col-100"
                          floating-label
                          outline
                          :label="'Justificantes'"
                          :form="rform"
                          :name="'controlCalidad.justificantes'"
                          :documentoAdapter="Documento"
                          :preview="true"
                        ></r-files>
                        <r-files
                          class="col-100"
                          floating-label
                          outline
                          :label="'Documentaciòn aportada'"
                          :form="rform"
                          :name="'controlCalidad.documentos'"
                          :documentoAdapter="Documento"
                          :preview="true"
                        ></r-files>
                      </f7-col>
                    </f7-row>
                  </f7-card-content>
                </f7-card>

                <f7-row v-noroles="['ADMINISTRATIVO','RESPONSABLE']" no-gap class="list list-form no-hairlines">
                  <template>
                    <f7-col width="100" medium="100" >
                      <r-input v-noroles="['INSPECTOR','ADMIN']"
                        floating-label
                        outline
                        :label="'Observaciones'"
                        :form="rform"
                        type="textarea"
                        :name="'controlCalidad.observaciones'"
                        :readonly="true"
                        :overrideReadonly="true"
                      ></r-input>
                      <r-input v-roles="['INSPECTOR','ADMIN']"
                        floating-label
                        outline
                        :label="'Observaciones'"
                        :form="rform"
                        type="textarea"
                        :name="'controlCalidad.observaciones'"
                        :readonly="rform.readonly || (rform.formData.estado && rform.formData.estado.estado !== 'CONTROL_FINAL')"
                        :overrideReadonly="true"
                      ></r-input>
                    </f7-col>
                  </template>
                  <template>
                    <!-- Fotos con nombre -->
                    <div class="fotos-con-nombre" style="width: 100%;" v-if="(rform.formData.controlCalidad && rform.formData.controlCalidad.fotosConNombre && rform.formData.controlCalidad.fotosConNombre.length > 0 || !rform.readonly) && permisosVer('fotos')">
                      <f7-navbar class="navbar valoracion-arreglos">
                        <f7-block-title>
                          {{$t('inspecciones.inspeccion_form.controlCalidad.fotosConNombre')}}
                        </f7-block-title>
                      </f7-navbar>
                      
                      <f7-card class="elevation-3 padding-vertical-half padding-right">
                        <f7-card-content>
                          <f7-list 
                            v-for="(fotoConNombre,index) in rform.formData.controlCalidad.fotosConNombre" 
                            :key="'controlCalidad-fotosConNombre-'+index"
                            class="fotoconnombre"
                          >
                            <div >
                              <f7-row>
                                <r-files 
                                  :form="rform" 
                                  :name="'controlCalidad.fotosConNombre.'+index+'.documentos'"
                                  :documentoAdapter="Documento" 
                                  :isObject="false"
                                  :readonly="rform.readonly || (rform.formData.estado && rform.formData.estado.estado !== 'CONTROL_FINAL')"
                                  :overrideReadonly="true"
                                >
                                  <template v-slot:topbar="{}">
                                  </template>
                                </r-files>
                              </f7-row>
                              <f7-row>
                                <r-input
                                  class="col-85" 
                                  :form="rform"
                                  type="text"
                                  :name="'controlCalidad.fotosConNombre.'+index+'.nombre'"
                                  :readonly="rform.readonly || !fotoConNombre.editable || (rform.formData.estado && rform.formData.estado.estado !== 'CONTROL_FINAL')"
                                  :overrideReadonly="true"
                                ></r-input>
                                <r-input
                                  class="col-20"
                                  :form="rform"
                                  type="check"
                                  :simple="true"
                                  v-tooltip="fotoConNombre.visible?$t('inspecciones.inspeccion_form.visible'):$t('inspecciones.inspeccion_form.oculto')"
                                  :name="'controlCalidad.fotosConNombre.'+index+'.visible'"
                                  :key="'controlCalidad.fotosConNombre.'+index+'.visible'"
                                  :readonly="rform.readonly || (rform.formData.estado && rform.formData.estado.estado !== 'CONTROL_FINAL')"
                                  :overrideReadonly="true"
                                ></r-input>
                              </f7-row>

                            </div>
                          </f7-list>
                        </f7-card-content>
                      </f7-card>
                    </div>
                    <!-- Fin de fotos con nombre -->
                  </template>
                </f7-row>
              </f7-card-content>
            </f7-card>
          </template>
          <!-- Datos de control de calidad -->

          <!-- gastos de reacondicionamiento -->
          <template v-if="permisosVer('arreglos')">
            <f7-block-title>Gastos de reacondicionamiento</f7-block-title>
            <f7-card>
              <f7-card-content>
                <f7-row no-gap class="list list-form no-hairlines">
                  <template>
                    <f7-col width="100" medium="33" >
                      <r-input
                        floating-label
                        :label="'Factura carrocería'"
                        :form="rform"
                        type="text"
                        :name="'facturasArreglos.facturaChapa'"
                      ></r-input>
                    </f7-col>
                    <f7-col width="100" medium="33" >
                      <r-input
                        floating-label
                        :label="'Fecha factura carrocería'"
                        :form="rform"
                        type="datepicker"
                        name="facturasArreglos.fechaFacturaChapa"
                        :calendar-params="{closeOnSelect:true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit' } }"
                      ></r-input>
                    </f7-col>
                    <f7-col width="100" medium="33" >
                      <r-input
                        floating-label
                        :label="'Importe carrocería'"
                        :form="rform"
                        type="number"
                        step="0.01"
                        :name="'facturasArreglos.importeChapa'"
                      ></r-input>
                    </f7-col>
                    <f7-col width="100" medium="33" >
                      <r-input
                        floating-label
                        :label="'Factura mecánica'"
                        :form="rform"
                        type="text"
                        :name="'facturasArreglos.facturaMecanica'"
                      ></r-input>
                    </f7-col>
                    <f7-col width="100" medium="33" >
                      <r-input
                        floating-label
                        :label="'Fecha factura mecánica'"
                        :form="rform"
                        type="datepicker"
                        name="facturasArreglos.fechaFacturaMecanica"
                        :calendar-params="{closeOnSelect:true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit' } }"
                      ></r-input>
                    </f7-col>
                    <f7-col width="100" medium="33" >
                      <r-input
                        floating-label
                        :label="'Importe mecánica'"
                        :form="rform"
                        type="number"
                        step="0.01"
                        :name="'facturasArreglos.importeMecanica'"
                      ></r-input>
                    </f7-col>
                    <f7-col width="0" medium="20">
                    </f7-col>
                  </template>
                  <template>
                    <f7-block-title class="col-100">Facturas de reacondicionamiento</f7-block-title>
                    <f7-col width="100" medium="100">
                      <r-files 
                        class="col-100"
                        :form="rform" 
                        :name="'facturasArreglos.documentos'" 
                        :label="'Facturas de reacondicionamiento'" 
                        :documentoAdapter="Documento"
                        :preview="false"
                      ></r-files>
                    </f7-col>
                    <f7-col width="100" medium="100" >
                      <r-input
                      floating-label
                      :label="'Observaciones'"
                      :form="rform"
                      type="textarea"
                      :name="'facturasArreglos.observaciones'"
                      ></r-input>
                    </f7-col>
                  </template>
                </f7-row>
      
              </f7-card-content>
            </f7-card>
          </template>
          <!-- gastos de reacondicionamiento -->









          <!-- Conflictos -->
          <div v-if="false">
            <f7-block-title>
              {{$t('inspecciones.inspeccion_form.conflictos')}}
            </f7-block-title>

            <f7-card
              v-if="!rform.formData.conflictos || rform.formData.conflictos.length == 0"
            >
              <f7-card-content>
                {{$t('inspecciones.inspeccion_form.no_conflictos')}}
              </f7-card-content>
            </f7-card>

            <f7-card
              class="elevation-3 padding-vertical-half padding-right"
              v-for="(item,index) in rform.formData.conflictos"
              :key="'conflicto-'+index"
            >
              <f7-card-content>
                <f7-list class="list-form">
                  <ul>
                    <f7-row>
                        <r-input
                          class="col-50"
                          floating-label
                          :label="$t('conflictos.conflicto_form.estandar')"
                          :form="rform"
                          type="text"
                          :name="'conflictos.'+index+'.estandar'"
                        ></r-input>
                        <r-input
                          class="col-50"
                          floating-label
                          :label="$t('conflictos.conflicto_form.subestandar')"
                          :form="rform"
                          type="text"
                          :name="'conflictos.'+index+'.subEstandar'"
                        ></r-input>
                        <f7-col width="20" class="margin-top">
                          <li class="readonly" floating-label="" 
                            :label="$t('inspecciones.inspeccion_form.resolucion')">
                            <div class="item-content item-input item-input-with-value">
                              <div class="item-inner">
                                <div class="item-title item-label item-floating-label">{{$t('inspecciones.inspeccion_form.resolucion')}}</div>
                                <div class="item-input-wrap">
                                  <div v-html="getResolucionBadge(item.resolucion)"></div>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li class="readonly" floating-label="" 
                            :label="$t('conflictos.conflicto_form.tipo_conflicto')">
                            <div class="item-content item-input item-input-with-value">
                              <div class="item-inner">
                                <div class="item-title item-label item-floating-label">{{$t('conflictos.conflicto_form.tipo_conflicto')}}</div>
                                <div class="item-input-wrap">
                                  <div v-html="getTipoConflictoBadge(item.tipoConflicto)"></div>
                                </div>
                              </div>
                            </div>
                          </li>
                          <f7-button
                            fill
                            icon-f7="eye"
                            text="Ver Incidencia"
                            class="display-flex margin"
                            :href="'/conflictos/view/' + item.id + '/'"
                          ></f7-button>
                        </f7-col>
                        <r-input
                          class="col-40 margin-top"
                          floating-label
                          :label="$t('inspecciones.inspeccion_form.comentario_inspector')"
                          :form="rform"
                          type="textarea"
                          :name="'conflictos.'+index+'.comentario'"
                        ></r-input>
                        <r-input
                          class="col-40 margin-top"
                          floating-label
                          :label="$t('inspecciones.inspeccion_form.comentario_resolucion')"
                          :form="rform"
                          type="textarea"
                          :name="'conflictos.'+index+'.comentarioResolucion'"
                        ></r-input>
                    </f7-row>
                  </ul>
                </f7-list>
              </f7-card-content>
            </f7-card>
          </div>
          <!-- Fin Conflictos -->


          <div v-if="inspeccion.verDatosInspeccion && permisosVer('informes')">
            <f7-block-title><f7-link @click="popupConcatenarDocumentosOpened = true" icon-f7="arrow_down_doc_fill"> {{$t('inspecciones.inspeccion_form.fichero_unico')}}</f7-link></f7-block-title>
          </div>

          <!-- Documentos adjuntados -->
          
          <div v-if="inspeccion.verDatosInspeccion && permisosVer('adjuntos')">
            <f7-block-title>
              {{$t('inspecciones.inspeccion_form.documentos')}}
              <!-- Opción de añadir documenos a la certificación (Solo para perfiles ADMINISTRATIVO e INSPECTOR) -->
              <r-form
                v-roles="{route: $f7route.url, roles: ['ADMINISTRATIVO', 'RESPONSABLE', 'INSPECTOR']}"
                class="form-inline"
                v-slot="{rform}"
                :readonly="false"
                :beforeSave="beforeAddDoc"
                @save="onAddDoc"
                @error="() => rform.clear()"
                :documentoAdapter="Documento"
                :defaultData="{docsNuevos:[]}"
              >
                <r-files :form="rform" name="documento" :label="$t('common.addDoc')" @loadFiles="() => rform.saveItem()" :preview="false"></r-files>
              </r-form>
            </f7-block-title>

            <f7-card  v-if="(rform.formData.documentos && rform.formData.documentos.length > 0)" class="elevation-3 padding-vertical-half padding-right">
              <f7-card-content>
                <f7-row no-gap>
                  <r-files :form="rform" name="documentos" />
                </f7-row>
              </f7-card-content>
            </f7-card>
          </div>

          <!-- Fin Documentos adjuntados -->

          <!-- Ordenes de taller generadas-->
          
          <div
            v-if="rform.formData.ordenesDeTaller && rform.formData.ordenesDeTaller.length > 0 && inspeccion.verDatosInspeccion  && permisosVer('ordenestaller')">

            <f7-block-title>
              {{$t('inspecciones.inspeccion_form.ordenesdetaller')}}
            </f7-block-title>

            <f7-card class="elevation-3 padding-vertical-half padding-right">
              <f7-card-content>
                <f7-row no-gap>
                  <div class="orden-taller"
                    v-for="(ot,indexOt) in rform.formData.ordenesDeTaller"
                    :key="'ot-'+indexOt"
                  >
                    <!-- {{ ot.documento.nombre.split('-')[0] + ' (' + formatFecha(ot.fechaEnvio) +')' }} -->
                    <r-files
                      class="una-foto"
                      :form="rform"
                      :prefixKey="'ot-'+indexOt"
                      :name="`ordenesDeTaller.${indexOt}.documento`"
                      :documentoAdapter="Documento"
                      :isObject="false"
                      :maxFiles="1"
                      :preview="false"
                      :readonly="true"
                      :overrideReadonly="true"
                    ></r-files>
                  </div>
                </f7-row>
              </f7-card-content>
            </f7-card>
          </div>

          <!-- Fin Ordenes de taller generadas -->
          
          <!-- formato: caracteristicas y comprobaciones -->
          <div v-if="rform.formData.formato" class="torn-paper"></div>
          <f7-block-title>
            {{$t('inspecciones.inspeccion_form.formato')}}{{ rform.formData.formato?' - '+rform.formData.formato.nombre:'' }}
          </f7-block-title>
          <div v-noroles="['TECNICO']">

            <f7-card
              v-if="!rform.formData.caracteristicas || rform.formData.caracteristicas.length == 0"
            >
              <f7-card-content>
                {{$t('inspecciones.inspeccion_form.no_caracteristicas')}}
              </f7-card-content>
            </f7-card>
            <f7-card
              class="elevation-3 padding-vertical-half padding-right"
              v-for="(item,index) in rform.formData.caracteristicas"
              :key="'caracteristica-'+index"
            >
              <r-caracteristica 
                :caracteristica="item" 
                :name="'caracteristicas.'+index" 
                :form="rform" 
                :readonly="false"
                :overrideReadonly="false"></r-caracteristica>
            </f7-card>
          </div>
          <!-- Fin Características -->


          <!-- Comprobaciones -->
          <div v-noroles="['TECNICO']"  v-if="rform.formData.comprobaciones && rform.formData.comprobaciones.length">

            <f7-block-title>
              {{$t('inspecciones.inspeccion_form.comprobaciones')}}
            </f7-block-title>

            <f7-card
              v-if="!rform.formData.comprobaciones || rform.formData.comprobaciones.length == 0"
            >
              <f7-card-content>
                {{$t('inspecciones.inspeccion_form.no_comprobaciones')}}
              </f7-card-content>
            </f7-card>

            <f7-card
              class="elevation-3 padding-vertical-half padding-right"
              v-for="(item,index) in rform.formData.comprobaciones"
              :key="'comprobacion-'+index"
            >
              <r-comprobacion :comprobacion="item" :name="'comprobaciones.'+index" :form="rform"></r-comprobacion>
            </f7-card>
          </div>
          <!-- Fin Comprobaciones -->
        </div>
      </div>

      <!-- Documentos aportados por el cliente -->
      <div v-if="comprobarConfiguracion('DOCUMENTACION_CLIENTE','true')">
        <f7-block-title>
          {{$t('inspecciones.inspeccion_form.documentacionAportada')}}
          <f7-link
            class="col-10"
            v-roles="{route: $f7route.url, roles: ['ADMINISTRATIVO','RESPONSABLE']}"
            v-if="formDocAportadaReadonly"
            icon-f7="pencil"
            :text="$t('common.editar')"
            @click="formDocAportadaReadonly = false;"
          ></f7-link>
          <f7-link
            class="col-10"
            v-roles="{route: $f7route.url, roles: ['RESPONSABLE','ADMINISTRATIVO']}"
            v-else
            
            icon-f7="floppy_disk"
            :text="$t('inspecciones.inspeccion_form.guardarDocumentacionAportada')"
            @click.prevent="rform.saveItem(true);"
          ></f7-link>
        </f7-block-title>
        <f7-card>
          <f7-card-content>
            <r-files 
              class="col-100"
              :form="rform" 
              :name="'lineaPedido.documentacionAportada'" 
              :label="$t('common.addDoc')" 
              :documentoAdapter="Documento"
              :fileExtensions="getValorConfiguracion('DOCUMENTACION_CLIENTE_EXTENSIONES')"
              :preview="true"
              :overrideReadonly="true"
            ></r-files>
              <!-- 
               -->
          </f7-card-content>
        </f7-card>
      </div>
      <!-- Fin documentos aportados por el cliente -->
      <pre style="display:none;">{{rform.formData}}</pre>
    </r-form>

    <ModificarEstado ref="modificarEstado" :inspeccion="inspeccion" @finished="reloadPage"/>
    <OrdenTrabajo ref="ordenTrabajo" :inspeccion="inspeccion" @finished="reloadPage"/>
    <HistoricoEstadosPopup ref="historicoEstados" :inspeccion="inspeccion"/>
    <EstimarTarea ref="estimarTarea" :inspeccion="inspeccion" @finished="reloadPage"/>
    <ModificarEstimacionTarea ref="modificarEstimacionTarea" :inspeccion="inspeccion" @finished="reloadPage"/>
    <TerminarTarea ref="terminarTarea" :inspeccion="inspeccion" @finished="reloadPage"/>
    <ControlCalidad ref="controlCalidad" :inspeccion="inspeccion" @finished="reloadPage"/>
    <ValorarArreglos ref="valorarArreglos" :inspeccion="inspeccion" @finished="reloadPage"/>

    <f7-popup 
      v-if="popupSolicitarGarantiaOpened" 
      :opened="true" 
      @popup:closed="popupSolicitarGarantiaOpened = false"
      ref="popupSolicitarGarantia" 
      class="popup-solicitar-garantia" 
      swipe-to-close
      @popup:open="prepareSolicitarGarantia"
    >
      <f7-page>
        <f7-navbar >
          <f7-nav-title sliding>Solicitar garantía mecánica</f7-nav-title>
          <f7-nav-right>
            <f7-link popup-close>Close</f7-link>
          </f7-nav-right>
        </f7-navbar>
        <r-form
          ref="rformSolicitarGarantia"
          v-slot="{rform}"
          :readonly="false"
          @save="solicitarGarantia"
        >
          <div class="col-100">

            <f7-card 
              class="elevation-3 padding-vertical-half padding-right"
            >
              <f7-card-content>
                <f7-list class="">
                  <f7-row class="col-100" style="border-booton: 1px solid grey;">
                    <r-input
                      outline
                      class="col-50"
                      floating-label
                      :label="$t('inspecciones.inspeccion_form.fechaIniGarantia')"
                      :form="rform"
                      type="datepicker"
                      name="fechaIniGarantia"
                      :calendar-params="{closeOnSelect:true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit' } }"
                    ></r-input>
                    <r-input
                      outline
                      class="col-50"
                      floating-label
                      :label="$t('inspecciones.inspeccion_form.fechaFinGarantia')"
                      :form="rform"
                      type="datepicker"
                      name="fechaFinGarantia"
                      :calendar-params="{closeOnSelect:true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit' } }"
                    ></r-input>
                  </f7-row>
                </f7-list>
              </f7-card-content>
            </f7-card>
            <f7-card 
              class="elevation-3 padding-vertical-half padding-right"
            >
              <f7-card-content>
                <f7-list class="">
                  <f7-row class="col-100" >
                    <r-input
                      outline
                      floating-label
                      class="col-50"
                      :label="'Marca'"
                      :form="rform"
                      type="text"
                      name="coche.modelo.marca.nombre"
                      :readonly="true"
                      :overrideReadonly="true"
                    />
                    <r-input
                      outline
                      floating-label
                      class="col-50"
                      :label="'Modelo'"
                      :form="rform"
                      type="text"
                      name="coche.modelo.nombre"
                      :readonly="true"
                      :overrideReadonly="true"
                    />
                    <r-input
                      outline
                      floating-label
                      class="col-50"
                      :label="'Matrícula'"
                      :form="rform"
                      type="text"
                      name="coche.matricula"
                    />
                    <r-input
                      outline
                      floating-label
                      class="col-50"
                      :label="'Kilómetros'"
                      :form="rform"
                      type="text"
                      name="kilometros"
                    />
                    <!-- <r-input
                      outline
                      floating-label
                      class="col-50"
                      :label="'Código Inspección'"
                      :form="rform"
                      type="text"
                      name="codigoInspeccion"
                      :readonly="true"
                      :overrideReadonly="true"
                    /> -->
                  </f7-row>
                </f7-list>
              </f7-card-content>
            </f7-card>
            <f7-card 
              class="elevation-3 padding-vertical-half padding-right"
            >
              <f7-card-content>
                <f7-list class="">
                  <f7-row class="col-100" >
                      <r-input
                        outline
                        floating-label
                        class="col-100"
                        :label="'Nombre y Apellidos'"
                        :form="rform"
                        type="text"
                        :clearButton="false"
                        :placeholder="'Introduzca el nombre y apellidos del comprador'"
                        name="nombreComprador"
                      />
                      <r-input
                        outline
                        floating-label
                        class="col-50"
                        :label="'D.N.I.'"
                        :form="rform"
                        type="text"
                        :clearButton="false"
                        :placeholder="'Introduzca el D.N.I. del comprador'"
                        name="dniComprador"
                      />
                  </f7-row>
                  <f7-row class="col-100" >
                      <r-input
                        outline
                        floating-label
                        class="col-100"
                        :label="'Dirección'"
                        :form="rform"
                        type="text"
                        :clearButton="false"
                        :placeholder="'Introduzca la dirección del comprador'"
                        name="direccionComprador.direccion"
                      />
                      <r-input
                        outline
                        floating-label
                        class="col-70"
                        :label="'Población'"
                        :form="rform"
                        type="text"
                        :clearButton="false"
                        :placeholder="'Introduzca la población del comprador'"
                        name="direccionComprador.poblacion"
                      />
                      <r-input
                        outline
                        floating-label
                        class="col-30"
                        :label="'Código Postal'"
                        :form="rform"
                        type="text"
                        :clearButton="false"
                        name="direccionComprador.cp"
                      />
                      <r-input
                        outline
                        floating-label
                        class="col-30"
                        :label="'Provincia'"
                        :form="rform"
                        type="text"
                        :clearButton="false"
                        :placeholder="'Introduzca la provincial del comprador'"
                        name="direccionComprador.provincia"
                      />
                  </f7-row>
                  <f7-row class="col-100" >
                      <r-input
                        outline
                        floating-label
                        class="col-30"
                        :label="'Teléfono'"
                        :form="rform"
                        type="text"
                        :clearButton="false"
                        :placeholder="'Introduzca el teléfono del comprador'"
                        name="telefonoComprador"
                      />
                      <r-input
                        outline
                        floating-label
                        class="col-70"
                        :label="'e-Mail'"
                        :form="rform"
                        type="text"
                        :clearButton="false"
                        :placeholder="'Introduzca el e-mail del comprador'"
                        name="emailComprador"
                      />
                    </f7-row>
                  </f7-list>
              </f7-card-content>
            </f7-card>
            <f7-card 
              class="elevation-3 padding-vertical-half padding-right"
            >
              <f7-card-content>
                <f7-list class="">
                    <f7-row class="col-100" >
                      <f7-button
                        class="display-flex margin-left col-100"
                        fill
                        icon-f7="cart"
                        text="Enviar solicitud"
                        color="purple"
                        @click="solicitarGarantia"
                      ></f7-button>
                    </f7-row>
                </f7-list>
              </f7-card-content>
            </f7-card>
          </div>
        </r-form>
      </f7-page>
    </f7-popup>










    <f7-popup 
      v-if="popupResumenGastos" 
      :opened="true" 
      @popup:closed="popupResumenGastos = false"
      ref="popupResumenGastos" 
      class="popup-resumen-gastos" 
      swipe-to-close
      @popup:open="prepareResumenGastos()"
      tablet-fullscreen
    >
      <f7-page>
        <f7-navbar >
          <f7-nav-title sliding>Resumen de Gastos de Pre-certificación</f7-nav-title>
          <f7-nav-right>
            <f7-button
              class="display-flex margin-left"
              fill
              icon-f7="floppy_disk"
              text="Guardar"
              color="blue"
              @click="generarOrdenTaller('rformResumenGastos')"
            ></f7-button>
            <f7-link popup-close>Close</f7-link>
          </f7-nav-right>
        </f7-navbar>
        <r-form
          ref="rformResumenGastos"
          v-slot="{rform}"
          :readonly="false"
          @save="generarOrdenTaller('rformResumenGastos')"
        >
          <div v-if="rform" class="page-popup">
            <table style="width:500pt;background: transparent;border-collapse: collapse;">
                <colgroup>
                    <col width="45%" />
                    <col width="5%" />
                    <col width="45%" />
                </colgroup>
                <tr>
                    <td>
                        <img alt="CarsCars" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHsAAAAdCAYAAACKahM4AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAABUVSURBVGhD5Vp5dE131z6ZiRQxR1TFFCGJREINjaGGGIrWUJQixggRVKngfakpOmiDaLVaKtpqXnOkhmoNNVOqGkGQSBsxJiExRBLP9+zfOUduhvbz/vGtpb691l7n3nP2b9rPHs+9Gv6fUH5GBu7t24esVatwOyoKt1eswP2dO5F79aoh8ezTMw/2w8REXJ84EZdq10aCjQ3OaJris+QEa2tcdHFB2ujRyElIMEY8u/RMg5317bdIrF5dgZtAPmeAbMlyX54nEvSsTZuMkc8m/S3YWfdycOJcKmL3n0HcgTM4eT4Vmdn3jadPN90h0GdLly4GrgB+gXze4ruwgJ5YqRLuHzxozFCcHj16hPika1i+6QDeidqCd5Zswcdr92D/b0m4++ChIfX0Uolg3yHIi2P2ovGAeXBoPhZak1HQ/Eaqzw36zML0T7ci7dYdQ/rpozvx8Uh0dS0GtIAs1wPk3yy+C5uAX+nWDfl5ecZMBZSSlokRc75G2dbjoXkPh+Y5FFqjIH4eBpumwWgV9AEdIt6QfjqpGNgpaRkIHL8UmtcwnX1HQvMhNyH7jlCH0xoOgWe/edh/6pIx6umhOzk5iA7sVixsC7Dfk9uQy5O9yKvJJuCm7HknJ+ScPGnMptOpC1fh1W8OwR0CrTGBVsY/msxrE15FNwTf/sUxiFi90xj19FEhsNPvPED7MZEEc7B+AHWgYOXVCmj1WQ5KbjAEIQu/M0Y+PbQ5NhafWlnhogGeCaSE7bXt22NZdDQiFi1Cjbp1UZ/3ThrPLQ3j9po1xmzA1fQs+DLCKU8WnfhTBwrcgQT/DeqFxq/0Ql3RCcZFrDVGPn1UCOypket1b5bDiMU2GACtfCNothWg2VWEVtmbB+xP6x6Juh2DkXzlujGygCSv3cjMRkLydZxLuYGMJ8zxDx/mIS8/3/im033eO8s5bheZI59rJKel49DpSzh+9k+k3SxIKWNDQ/E1AROwBUDTw+Wa/u67hhSwe/9+1GFOP8T74t3yXICWYi1z9Wpd6FE+Rs9dTWAZrpXxE9S6PaA51oBmXRqaZg3N3hmaWztlDF5dQnD12k19rAVJWjzIvP7NjhPk4/yc/EQ5Pu1mFq6n3zW+6ZR64zbW7jqB85cL6z4z+wG2Hz6DLzbtx8rY/fj+UDyu3Moynur0GOy4H/ejlB8P5UMPFqBptV7NOyJ4zChMnDgB3Tp3QulSDjxgKZRtGIi4XfuMkQV08HQKBsz4ArW7z0D5thPh3HYSGvSehXAWM1csAClKh6iIwNClmPVZHI1FB3Pznt/xcvDHKNUyFP/h4Uw6k3wDA2euQpUOkxk2Q1C6xTg832Uq+k5bgZ1Hz6Fl23b4gIAlGeCZni1gXnJ3x8PkZDXPzfR0LGIFXlQmkQZw78gRJROzOQ7WXm9SJ3o0s/YeiB79hiL6q5XYuGED3ouIgKeHB3WiwaVBKxz55ZQaZ0nr9/0OnwFzYd+MtU9j6tZrOOybh6BF0HvYuv93Q6owPcjNx6q4o6j36ky0GbkI1zOyaBy5eG/1D6j5SriKqqIrk348dh5+b0bAWiJuQ2LIWsKKqeaF7uGYsnjjY90rsO/fy0bL7hKamJMkZDMvDZq2FBk3byghoXx63Y4dO+Hp6YUVny037hbQzRs34NvrHWjuTAGS132Y28RwJFIw1zUeOA+/XUwzpHXKz3+EaVGxcCSgEgJtuMGI6B8xhunBTjYuodNjCKYti1XyR+KTUav7dCWr5veljFxFiZQrFzAJL/i+hNeo/EtkCd2mxwrL58sBAchh731z/nycYbgXkIXN56ldu8rGcDc7C007E+hG3IPsxSsIYxesYfFW2COvX7+B0NDx2LK5eNt27txZNOnCvREcPVrqRqNSIuctRWP9ZOMBQ1onMfbgBd8oo5A1Ra77W8vRdcIy6oO6FN0y0rw2Rcfgh6OJKN96gtJx4TXIlLOmoW76WTcqBXZcXBys3DpSiB5NgJxeClPhsSS6RY/Iy8s1vhXQhAlhDGkM9SrcjdEXNHO+bICbaTZ0IdKzCkJyzLr1cHZrSvAGMRdSlsWgtchKESSFoczFDQeGLkH23XtoNWQ+ZSV3mnOT5bPkUSrlzfAVWBz1CRwI2nfkywaAptea1wtssc7Z2hbyaGUYFSo89uqdO7ZBq9Wea/AsNKjSrcbjWEKKelaUJHUJF6UFNChNs+WemQ59eSZvKfAkJRj7J5jOARNwNL5g3s8/+xxlyrtAq/+qrhPRgQAsHYAJpvcI+AxcgAuX/4T/gFk8O+cUfSvdUT8+sgZl6RQjZhY4pgI7dMJkaLW7U4CTewfBm2En636OEnhSimVhZG3NHObsDq0Uc5oDN1yuNrR6nfVNCHj01OXMKSZ9+P4HKgRqVbx0GcWUE8tXGx8GR88+eD96J96ZvVCvIURJooT6PfXcWdqV4/1Qp8MoJP9xBTcZjdwbNVLF109kycem51qypTdLyN9J3j13rrEzYOJkRqlaXfS1aHz1XvsXMiwM9Uno3LnzqFq1KvO7M6wcK8LKzlHP9VVY+/gKQJybESlkYUFRt2fPXrhUq0IdViZoBFkBbLA4Dh3DrmYbrNywG6ETuUc36sEwfGuPnrApwxpCDMy2Mvy6BSH1WkF01nJyHiCgXSeG3376IALSefwy4/GTU87DhxjQvz/69uqJaVPeRv/+/eDiUg2aDQ8nRZ0ojd73+jsrjBE6TZlMQ9NseOi+uoyEHyX7JuxdfPHqa71wPiEeHt7N1D1lwWwFq7foj6ChQ9GudUu4VK6IbUwxJm2N+x6lyjujKQE8ThavNcG1BF4+C0eR544cyULqnjED0LV7LxZjr1HJ3As90D9oIQvI4t77v9HSJYvxr5nT8VX0Gry74CN4N23NYrccDZfzS0Ri5Go6ZCFycgt6+00bN8LW1g5ana6UYWRRnRD34f46ajR8CeNZhP6Rkgzvxn40emMeGkPFFkGYNGM+wsLC0DagJY4cKnAsIS0zIx013OrroUYOxsW7TfrEePzfUdrNTESzsBgVEYO2oyNRpR2LEneGI28j7xHsLgzJljq7evUq6tSpC61mB8pw0yLHcOffsR/27v5JJbGkpCRUcXmec/FgIsOQKIXbSyMjMfHDGCxbE1usut0wJgTRBFGqa0uALQGX6+/kNYwEN1NTjZHAvZQUbGRr1rpWG64Xwv0Mg++gBXiYV7hbeBK6mHoLM5ZvY9iNQPUu01CuDfNrY4ZzCesSvRhJG70+B1n3Hhgj9Frm5bZcu3qADraSG4JeQ8OQfOmCknmYm8v6iZ1STaYaU4ZO4tx+MtoEL8bED2Jw9ExKIV1r6bduoWo1KrIhPVs8ios3G7ygkKU9CZ1KTEWLYe9zPK1QKkL18oHASBVqhmeC3TVsaaENCPXt0weaqxyM8hxXo9NEXEjSq2ah23fuwMuzIdtAVr4CtrJkzmm8+HFoPk6lnnW7f1XydyIjcYlVtRRplh5sfi8KurRpV1iY5Vy+jPy7d5Hau7eSPWFji5612VYxktToGo4/b/x3bw13HE7guGkqVKucK1FLaoBm43ilrsWwGTUa9SPY9wvAFgoJ5rNqLXQgWTNUaj8JiSnXjKc6delCz7ctyzkY8ZoK4NSLKoqpfxZzDi+Owcj53+D2XX1uLYuKrO/egLE/UFckNyVtzYU/iveLf0VS2nv2fZcgy8sYAZYLSliWOWsz74kly8GYIrpNiCoG9sA3BvJghhXTixr1exfZbDUsafLkt/X8LjWBB41DjEfkTeBZpJRmYbl+diSSncqoXGyCKmFcXp5sJieSTfDNok1kJAJc8vZGao8e6r6wervGij20mh/b0pHYwdbuSeki9efWjW2SVMkKVEY3V4bwip7M2T68/zr3LSliGDz7Fwd7yuS3oFXy1TGhA1QLnIqktAzjqU6bt8TCwd6edUAZzt2Kc72h60IBz6sA32AwZn3+vZLXpKXqHMhKvAKLBiVEJbKVWbq+eB9dIuXnITj8Q6VsHWj2o67NULZ8BThXcIadbMa9BzetpwjpnYuGwzGjeCAVsnjl4T1en6VeRFiSePdI5lUnR3mZQdAdWMBU9ee6NCpVvMjaI7C83PPKK00Q5Sot1nB6uh2v0/ldADdBNwE3Pwub40xDkaq+s2tLDJrzrbGbv6e83Bz0HjmVxm8Azf05NwhAYy9PtGjmj0qs+rWajBhN9fPW7z0LGdlFwZ5EsGkUygGGo2qnKbh0Jd14WkDr2NE09fOBvS3rHs2KhR3rpBrUpVTkysEYqdmD38/J1avxqW/TiqzLq3ChQJENsPq8mFrcu7PvP8RXW48+/vVrD/Oq/QvML2KlrLjtXwzGl1/H4ByLqksXL6B165e4OA8mm2Z17dZjerGqdlwIw5pLgWeXBLZOj7B9117MnTMbbVu3QtkyBN6axiSe7h+C2p59cdTOQQFpCdhZL28c3PczAl95RRlKEDmebL5lM2Ut2TSCZPKqcjVQznswzzYW3+4s/N5c6Gp6NsI+XIfjCX+o7z/v3QN71xf1sE2grZgeN+w4xCd6SBszih5XqQl1LV47QuXx0xcK/4kifBqNRYFNmb8BW+iHI/FYt3Er3p01E838GsPOhqDXkU5C5h+Gur2oz7s5Oti7d+2CjR2rPzcpkgzvptKbsCiJO3gGqQzTV27dweHTKeg79XNlDBM+2qAWen9hBKMCNyVRweiNV31/XD3LY9To0p9GUI+FlfJ6HpzGtHHfafXcpHFjmNcV2PrB/grsP9JuoS2Ljzkrd7E3TUb0ui2o6sHwJe+om4YgoG5X5YmW1beE59TOgWp8xu3bGBrEPM97ncmHyX/VmgnLs+8dyqC6p7R8urE+FzAeYYvWYeuBeBXWl8bsY/HGftp9MF6kB93KzsGKzz6BVtaN5+V5xLuoy8H/Xo2Ua7dV3u8ZPFtV1qbXiz5nfrpV7dGkjxYxWlahQYhO6IRVO71dItiJyVdQ85VpaBuymG3tYXy1eR/qtx1EB2BqVI4bhJaspaQGU2A/ZNvUTqo/G8Z+L3nBwQUU4MNhwwFiVS6sJCXhy8YUqMwHkTH7MXcuN+7AvlAmFktmm+DYYiw6cPFWwz9QxZMCWp7L4bi4z4B5PHhB/hkrYFdnPpN1WViUCPajPAwJ41oerAu4B3lNWqnjFNjR29ReGRUCa3dSnmgJmAB53tkZDw4fVtPk5uXhX7Nlz6Xgw2cHycUigfFZ0sFaa1tUUGlIgOMZJA/Kmz2e1UrVOPLCwwiZDNsjF8Tgyy+/YMRxohwLJyl6ZX/MuxVZKVcmKyMwdSJX9SJrPL6zeC0c+ZEBtpGzq3aaWgLY+Xh9tBSAuk7UXnxFz8TJX+bnutRnxFe7lLQCW2jPnt14joWN5siY7y2blA1xoAArlbWwbFo2x4PasHVYvukgtm6NpadYQ3tBchAXkUPLu2Rpt+T1nvJo+W7xS5rncPQL/9IIagT7cRhnm8N1PPr+uxjYhw8fQxlvyc+idFmDSpf+U1W4ZI71rdUepwmQpWcLS0i+VL8+sjZswKMMGtmDB1g2aRLG8H7RPtyS5Z6E+g2OzqhfrzvXkPOJMg29iDLlbEpXo2Dr/Qb+s+s44uPjUa7sc4x49ShHvT3WC/crepRcLeM92JbKr2Yyno4VGBrFFKfn7sUfL1IvizR/6obdQJWXJxcD+8CB/SjtYRqizGnoQvYle2Qd1XrYfGQaafMx2EIffRwJeztbaPYs5+uwkpY3OOqAxmTKyggigek/Yjy9JBf37t1D+/bs9agUrXozblqKEkNWDinyzzNvy4uEOp15wAFwbhiIvccLfuhXYbyKjKVBNBgAP7Z+WawNLGnAgP4sPlzpPVKJS23B+dXeyBxnVbM1nOwdsdUAqChoqvBiqrpUpw6SPT2RVLmy8lwBWmTMHG3KW44VuZ3WdvCvzL7WvTf1wjMpwydLIVSPoFX2RXDoJBZnehcRHj5d14ljdZ67G/VAvSjDJ+D1+sCxZgumTgcWmY2h1eqBCvWa49jJgvQW+fFH0J5jKmBq0tw6o/ngeUgr8ivWsCCuLS+kalC/8uJKDEeMS17J1uWcDdri54P661+hQmALRUevQa1aXEQ2akvrdKrLg9DCKjIvl6kNp8o1ETo+DJnpt4wRwIULF9G+A/O9jLHiARxrsidmX8yxlV9oiIiICDTx5aH43K1hU3y2fLlKHSaNCSZwMpYbL+dcBXsP6/2yJYWHTzN+daOcHatZUYRTHa7lisrPu2NJ5GLU9WiAQXwuodwSOAHSElTL++ZnuYqMaQDmPZOlIo8jl5eK18pR/8nXvhKsSlVEfQ9PfLIsCg9zCqLRA0aPefMXoFoVdg0cp2ncuy2LYPuKaNS4mfrhZPQIAs9nHQNfwV4WdfnsbEyKioqCvYM9yjDalneugB9+2mM8KaBt27bBz88P1la67jRreR1LzOzLwce/OXZs11suk4qBLXQlNRVLFkeiZ/cerO6awN+/CTq2b4fp4eH45fgx9QtYUbp79y5iYmIQNHQIWjZvhtatWmFi2Hj8evIX9fzUqd8we9ZsJCddVN8t6fjx4zSy1fj6m6+xYcM6zpVtPCkg+aHh2LFjmDFjBvr27o0O7dqhT69XMXPmDPx+WveI6TNnwobKW8EWSwA3ATaBlWvRz/JcvgvIJ8jzyPK3JTM6iIzMI89OvPU2omioY8eGYDQratFHLEGTX/z+ipKTk7EmOhpT35qE0NBx+GrVl7h2Ta+8MzMzCdh23Mkq7LFCGUw3CWfO4GxCAs6dPasiaEkkLemuH3/EkiWLET51Ct6bPw9bY7dwfPFirkSwTRIFi4Xev38feSX8L+uvKJehTPj/kkr6n1haWhq8fX3xHIFZShbABEQTNLkKWxqByAhvIQ9xdYVDmTLw5uddZPmBRGTller6Dl1wK/Pp/d/dk9Dfgv1PpF9//RXuDZlCCFAf8kaytF8CqIRi8XhhAVJA3ECWvnvEa71wNikJn3/xBRydnkNN3ltLlkr9Ox8fJF2+bKzwz6VnDmyhFAITNHw4HJycYE2wPMhvkCeTp5EnkvuT/RnuWzZujE9WrsRdi9eV27ZvR9UaNVSEmPVCbZw/VfwfKP9EeibBFpIUdJq5fA6LpM6sPRr5+6Oqmxvqe3ohoFMnjA6bgI1b45DJnFcSnTxxAi0DAhC7bYdx559PzyzYliTAS4EjRU92djZySygwSyKpVZ4dAv4Hqch2cafY5V4AAAAASUVORK5CYII="
                        />
                    </td>
                    <td></td>
                    <td>
                        <p class="calibri fs11pt">
                            Ctra. N-II km 16,5 (entrada por gasolinera)<br/> S. Fernando de Henares 28830 – MADRID<br /> Tfno: 91 674 22 65 Fax: 91 674 22 70
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div style="background-color: yellow;text-align: center;border:2pt solid black;font-style: italic;">ORDEN DE TALLER</div>
                    </td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td colspan="3"> </td>
                </tr>
                <tr>
                    <td colspan="3"> </td>
                </tr>
                <tr>
                    <td>
                      <b>MODELO</b>
                      {{$refs.rform.formData.lineaPedido.coche.modelo.marca.nombre + ' ' + $refs.rform.formData.lineaPedido.coche.modelo.nombre}}
                    </td>
                    <td></td>
                    <td><b>MATRICULA</b> {{$refs.rform.formData.lineaPedido.coche.matricula}}</td>
                </tr>
                <tr>
                    <td colspan="3"> </td>
                </tr>
                <tr>
                    <td>
                      <b>DESTINO</b>
                      <r-input
                        class="col-100 input-text"
                        :form="rform"
                        type="text"
                        :clearButton="false"
                        :name="'ordenTaller.camposCabecera.DESTINO'"
                        :readonly="false"
                        :overrideReadonly="true"
                      >
                      </r-input>
                    </td>
                    <td></td>
                    <td>
                        <b>KILOMETROS</b>
                        {{valorCaracteristica('KILOMETROS')}}
                    </td>
                </tr>
                <tr>
                    <td colspan="3"> </td>
                </tr>
                <tr>
                    <td>
                        <div style="background-color: yellow;text-align: center;font-weight: bolder;">CARROCERÍA</div>
                    </td>
                    <td></td>
                    <td>
                        <div style="background-color: yellow;text-align: center;font-weight: bolder;">MECÁNICA</div>
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top;">
                        <table width="100%" style="background: transparent;border-collapse: collapse;border: 1pt solid black;">
                            <tr>
                                <td style="width: 60%;border: 1pt solid black;font-weight: bolder;">DESCRIPCIÓN</td>
                                <td style="width: 10%;border: 1pt solid black;font-weight: bolder;" class="fs8pt">PINTAR</td>
                                <td style="width: 30%;border: 1pt solid black;"></td>
                            </tr>
                            <tr v-for="(trabajo,indice) in rform.formData.trabajosCarroceria" :key="'trabajo-CARROCERIA-'+indice">
                                <td style="border: 1pt solid black;">
                                  <r-input
                                    class="col-100 input-text"
                                    style="border: 0; width: 100%;"
                                    :form="rform"
                                    type="text"
                                    :clearButton="false"
                                    :name="'trabajosCarroceria.'+indice+'.nombre'"
                                  >
                                  </r-input>
                                </td>
                                <td style="border: 1pt solid black;">
                                  <r-input
                                    class="col-100 input-text"
                                    style="border: 0; width: 70px;"
                                    :form="rform"
                                    type="text"
                                    :clearButton="false"
                                    :name="'trabajosCarroceria.'+indice+'.camposPersonalizados.pintar'"
                                  >
                                  </r-input>
                                </td>
                                <td style="border: 1pt solid black;">
                                  <r-input
                                    class="col-100 input-text"
                                    style="border: 0; width: 100%;"
                                    :form="rform"
                                    type="text"
                                    :clearButton="false"
                                    :name="'trabajosCarroceria.'+indice+'.camposPersonalizados.accion'"
                                  >
                                  </r-input>
                                </td>
                            </tr>
                            <tr>
                                <td style="border: 1pt solid black;"><b>TOTAL</b></td>
                                <td style="border: 1pt solid black;"></td>
                                <td style="border: 1pt solid black;">
                                  <r-input
                                    class="col-100 input-text"
                                    style="border: 0; width: 100%;"
                                    :form="rform"
                                    type="text"
                                    :clearButton="false"
                                    :name="'ordenTaller.camposCabecera.carroceriaTotalArreglos'"
                                  >
                                  </r-input>
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td></td>
                    <td style="vertical-align: top;">
                        <table width="100%" style="background: transparent;border-collapse: collapse;border: 1pt solid black;">
                            <tr>
                                <td style="width: 70%;border: 1pt solid black;font-weight: bolder;">DESCRIPCIÓN</td>
                                <td style="width: 30%;border: 1pt solid black;"></td>
                            </tr>
                            <tr v-for="(trabajo,indice) in rform.formData.trabajosMecanicos" :key="'trabajo-MECANICO-'+indice">
                                <td style="border: 1pt solid black;">
                                  <r-input
                                    class="col-100 input-text"
                                    style="border: 0; width: 100%;"
                                    :form="rform"
                                    type="text"
                                    :clearButton="false"
                                    :name="'trabajosMecanicos.'+indice+'.nombre'"
                                  >
                                  </r-input>
                                </td>
                                <td style="border: 1pt solid black;">
                                  <r-input
                                    class="col-100 input-text"
                                    style="border: 0; width: 100%;"
                                    :form="rform"
                                    type="text"
                                    :clearButton="false"
                                    :name="'trabajosMecanicos.'+indice+'.camposPersonalizados.accion'"
                                  >
                                  </r-input>
                                </td>
                            </tr>
                            <tr>
                                <td style="border: 1pt solid black;"><b>TOTAL</b></td>
                                <td style="border: 1pt solid black;">
                                  <r-input
                                    class="col-100 input-text"
                                    style="border: 0; width: 100%;"
                                    :form="rform"
                                    type="text"
                                    :clearButton="false"
                                    :name="'ordenTaller.camposCabecera.mecanicaTotalArreglos'"
                                  >
                                  </r-input>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>

                <tr>
                    <td colspan="3">
                        OBSERVACIONES:<br/>
                        <r-input
                          class="col-100 input-text"
                          style="width: 736px; height: 80px;" 
                          :form="rform"
                          type="textarea"
                          :clearButton="false"
                          :name="'ordenTaller.camposCabecera.Observaciones'"
                        >
                        </r-input>
                    </td>
                </tr>
                <tr>
                    <td>
                        DIRECCIÓN POST-VENTA<br/>
                        <r-input
                          class="col-100 input-text"
                          style="width: 250pt;height: 60pt;" 
                          :form="rform"
                          type="textarea"
                          :clearButton="false"
                          :name="'ordenTaller.camposCabecera.postventa'"
                        >
                        </r-input>
                    </td>
                    <td></td>
                    <td>
                        DIRECCIÓN GENERAL<br/>
                        <r-input
                          class="col-100 input-text"
                          style="width: 250pt;height: 60pt;" 
                          :form="rform"
                          type="textarea"
                          :clearButton="false"
                          :name="'ordenTaller.camposCabecera.general'"
                        >
                        </r-input>
                    </td>
                </tr>
            </table>
          </div>
        </r-form>
      </f7-page>
    </f7-popup>


    <f7-popup 
      v-if="popupConcatenarDocumentosOpened" :opened="true" @popup:closed="popupConcatenarDocumentosOpened = false"
      ref="popupConcatenarDocumentos" 
      class="popup-concatenar-documentos"
      @popup:open="preparePopUpConcatenarDocumentos()"
    >
      <!-- @popup:open="console.log(this)" -->
      <f7-page>
        <f7-navbar >
          <f7-nav-left>
            <f7-link @click="sortElements">Ordenar seleccionados</f7-link>
          </f7-nav-left>
          <f7-nav-title sliding>Crear pdf único</f7-nav-title>
          <f7-nav-right>
            <!-- <f7-link @click="preparePopUpConcatenarDocumentos">Limpiar</f7-link> -->
            <f7-link popup-close>Close</f7-link>
          </f7-nav-right>
        </f7-navbar>
        <r-form
          ref="rformConcatenarDocumentos"
          v-slot="{rform}"
          :readonly="false"
          @save="documentosConcatenados"
          :defaultData="{docs:[],tipoExport: ''}"
        >
          <div>
            <f7-card class="elevation-3 padding-vertical-half padding-right">
              <f7-card-content>
                <f7-list style="height: 468px;overflow-y: auto;">
                            <f7-row no-gap>
            <f7-col width="100" medium="100">
              <f7-list-item
                checkbox
                title="Todos"
                name="todos-documentos"
                :checked="getDocumentsChecked(rform.formData.docs).length === rform.formData.docs.length"
                :indeterminate="getDocumentsChecked(rform.formData.docs).length !== rform.formData.docs.length"
                @change="onSwitchDocumentsChecks(rform.formData.docs, $event)"
              ></f7-list-item>
            </f7-col>
          </f7-row>
                  <Container 
                    @drop="onDrop(rform.formData.docs, $event)"
                    drag-handle-selector=".column-drag-handle"
                    lock-axis="y"
                  >
                    <Draggable
                      v-for="(documento) in rform.formData.docs" 
                      :key="'documento-'+documento.path+'-checked'"
                    >
                      <f7-row no-gap>
                        <!-- <f7-col width="5" medium="5">
                          <span
                            class="column-drag-handle margin-left cursor-move col-5"
                            v-tooltip="$t('common.move')"
                          >&uarr;&darr;</span>
                        </f7-col> -->
                        <f7-col width="100" medium="100">
                          <f7-list-item
                            checkbox 
                            :checked="documento.selected"
                            @change="documentSelected(documento)"
                            class="column-drag-handle"
                            :style="'color: ' + documento.color +';'"
                            :title="documento.nombre + '.' + documento.extension"
                            v-tooltip="documento.nombre + '.' + documento.extension + ' ('+documento.origen+')'"
                            :key="'documento-'+documento.path+'-checked-check'"
                          ></f7-list-item>
                        </f7-col>
                      </f7-row>
                    </Draggable>
                  </Container>
                </f7-list>
              </f7-card-content>
            </f7-card>
            <f7-card class="elevation-3 padding-vertical-half padding-right">
              <f7-card-content>
                <f7-row>
                  <f7-col width="33" medium="33">
                    {{$t('inspecciones.inspeccion_form.generar_pdf')}}
                    <f7-radio 
                      v-tooltip="'Generar PDF'"
                      name="tipoExport" 
                      icon-f7="wrench"
                      value="PDF"
                      @change="setTipoExport('PDF')"
                      :readonly="false"
                      :disabled="false"
                      > </f7-radio>
                  </f7-col>
                  <f7-col width="33" medium="33" >
                    {{$t('inspecciones.inspeccion_form.generar_zip')}}
                    <f7-radio 
                      v-tooltip="'Generar ZIP'"
                      name="tipoExport" 
                      value="ZIP"
                      @change="setTipoExport('ZIP')"
                      :readonly="false"
                      :disabled="false"
                    > </f7-radio>
                  </f7-col>
                  <f7-col width="33" medium="33" >
                    <f7-button
                      fill
                      icon-f7="cloud_download_fill"
                      class="display-flex"
                      color="blue"
                      :disabled="rform.formData.tipoExport !== 'ZIP' && rform.formData.tipoExport !== 'PDF'"
                      @click="documentosConcatenados"> {{$t('inspecciones.inspeccion_form.descargar')}}</f7-button>
                  </f7-col>
                </f7-row>
              </f7-card-content>
            </f7-card>
          </div>
        </r-form>
      </f7-page>
    </f7-popup>

    <f7-popup
      v-if="popupHistoricoControlCalidadOpened"
      style="--f7-popup-tablet-width: 75%;"
      :opened="true"
      @popup:closed="popupHistoricoControlCalidadOpened = false"
      ref="popupHistoricoControlCalidad"
      class="popup-historico-calidad"
    >
      <template>
        <f7-page >
          <f7-navbar>
            <f7-nav-left>
            </f7-nav-left>
            <f7-nav-title sliding>Historico de controles de calidad</f7-nav-title>
            <f7-nav-right>
              <f7-link popup-close>Close</f7-link>
            </f7-nav-right>
          </f7-navbar>
          <f7-card
            v-if="$refs.rform.formData.historicoControlesCalidad && $refs.rform.formData.historicoControlesCalidad.length > 0"
            v-roles="{route: $f7route.url, roles: ['ADMINISTRATIVO', 'RESPONSABLE']}"
            class="elevation-3 padding-vertical-half padding-right"
            style="z-index: 1001;"
          >
            <f7-card-content
              v-for="(controlCalidad, index) in $refs.rform.formData.historicoControlesCalidad"
              :key="'controlCalidad-'+index"
            >
              <f7-block-title>
                {{ controlCalidad.codigo }} <r-badge v-if="controlCalidad.calificacion" :text="$t(controlCalidad.calificacion)" :color="getColorBadgeCalificacion(controlCalidad.calificacion)"></r-badge>
              </f7-block-title>
              <f7-row>
                <r-files
                  class="col-100 little-image"
                  floating-label
                  outline
                  :label="'INFORMES DE CONTROL DE CALIDAD'"
                  :form="$refs.rform"
                  :name="'historicoControlesCalidad.'+index+'.informes'"
                  :documentoAdapter="Documento"
                  :preview="false"
                  :readonly="true"
                  :overrideReadonly="true"
                ></r-files>
              </f7-row>
              <f7-row>
                <template>
                  <!-- Fotos con nombre -->
                  <div class="fotos-con-nombre" style="width: 100%;" v-if="($refs.rform.formData.historicoControlesCalidad && $refs.rform.formData.historicoControlesCalidad[index] && $refs.rform.formData.historicoControlesCalidad[index].fotosConNombre && $refs.rform.formData.historicoControlesCalidad[index].fotosConNombre.length > 0) && permisosVer('fotos')">
                    <f7-navbar class="navbar valoracion-arreglos">
                      <f7-block-title>
                        {{$t('inspecciones.inspeccion_form.controlCalidad.fotosConNombre')}}
                      </f7-block-title>
                    </f7-navbar>
                    
                    <f7-card class="elevation-3 padding-vertical-half padding-right">
                      <f7-card-content>
                        <f7-list 
                          v-for="(fotoConNombre,indexfcn) in $refs.rform.formData.historicoControlesCalidad[index].fotosConNombre" 
                          :key="'historicoControlesCalidad-'+index+'-fotosConNombre-'+indexfcn"
                          class="fotoconnombre"
                        >
                          <div >
                            <f7-row>
                              <r-files
                                :form="$refs.rform"
                                :name="'historicoControlesCalidad.'+index+'.fotosConNombre.'+indexfcn+'.documentos'"
                                :documentoAdapter="Documento"
                                :isObject="false"
                                :readonly="true"
                                :overrideReadonly="true"
                              >
                                <template v-slot:topbar="{}">
                                </template>
                              </r-files>
                            </f7-row>
                            <f7-row>
                              <r-input
                                class="col-85"
                                :form="$refs.rform"
                                type="text"
                                :name="'historicoControlesCalidad.'+index+'.fotosConNombre.'+indexfcn+'.nombre'"
                                :readonly="true"
                                :overrideReadonly="true"
                              ></r-input>
                              <r-input
                                class="col-20"
                                :form="$refs.rform"
                                type="check"
                                :simple="true"
                                v-tooltip="fotoConNombre.visible?$t('inspecciones.inspeccion_form.visible'):$t('inspecciones.inspeccion_form.oculto')"
                                :name="'historicoControlesCalidad.'+index+'.fotosConNombre.'+indexfcn+'.visible'"
                                :key="'historicoControlesCalidad.'+index+'.fotosConNombre.'+indexfcn+'.visible'"
                                :readonly="true"
                                :overrideReadonly="true"
                              ></r-input>
                            </f7-row>

                          </div>
                        </f7-list>
                      </f7-card-content>
                    </f7-card>
                  </div>
                  <!-- Fin de fotos con nombre -->
                </template>
              </f7-row>
            </f7-card-content>
          </f7-card>
        </f7-page>
      </template>
    </f7-popup>

  </f7-page>
</template>
<style>

.smooth-dnd-container.horizontal {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex !important;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-items: flex-start;
  --f7-cols-per-row: 1;
}
.smooth-dnd-container.horizontal > .smooth-dnd-draggable-wrapper {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex !important;
  flex: 0 0 60%;
  margin: auto;
}
.draggable-item-horizontal {
  width: 100%;
}
.draggable-item-horizontal img {
  pointer-events: none;
}
.smooth-dnd-container {
  min-height: 0;
}
  div.navbar div.left li.ensanchar div.input-dropdown select.input-with-value {
    padding-right: 17px;
  }

  
td li.col-100 div.item-content,
td li.col-100 div.item-content div,
td li.col-100 div.item-content div div,
td li.col-100 div.item-content div div textarea.input-with-value {
  width: 100%;
  height: 100%;
}

.badge-estado-coche .badge {
  width: 100%;
}
.fotos-con-nombre .navbar-bg {
  background-color: transparent !important;
}
</style>
<style scoped>
.historicoEstados {
  max-height: 400px;
  overflow: auto;
}
.top-buttons {
  justify-content: end;
}
.top-buttons a{
  margin-right: 2px;
  margin-left: 2px;
}

.form-inline {
  display: inline-flex;
  margin-top: 0;
  margin-bottom: 0;
}
.fotoconnombre {
  border: 1px dashed grey;
  display: inline-flex;
  margin: 3px;
  padding: 3px;
}
.fotonombre {
  display: block;
}

.input-text {
  display: inline-flex;
  border: 1px solid black;
}

.page-popup {
  padding: 0 15px 15px 15px;
  display: flex;
  justify-content: center;
}

.torn-paper {
  width: 100%;
  height: 40px;
  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjQwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0wLDIwIEwzMCwxNSBMNTAsMjAgTDEwMCwyMCBMMTUwLDE1IEwyMDAsMjAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iNSIvPgogIDxwYXRoIGQ9Ik0wLDE1IEwzMCwxMCBMNTAsMTUgTDEwMCwxNSBMMTUwLDEwIEwyMDAsMTUiIGZpbGw9Im5vbmUiIHN0cm9rZT0iZ3JheSIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgPHBhdGggZD0iTTAsMjUgTDMwLDIwIEw1MCwyNSBMMTAwLDI1IEwxNTAsMjAgTDIwMCwyNSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJsaWdodGdyYXkiIHN0cm9rZS13aWR0aD0iMSIvPgo8L3N2Zz4=');
  background-size: contain;
}

.little-image .rfiles-item {
  height: 20px !important;
}

</style>
<script>
import rForm from "./../../components/rForm.vue";
import rInput from "./../../components/rInput.vue";
import rBadge from './../../components/rBadge.vue';
import rFiles from "./../../components/rFiles.vue";
import rCaracteristica from "./../../components/rCaracteristica.vue";
import rComprobacion from "./../../components/rComprobacion.vue";
import rAutocomplete from "./../../components/rAutocomplete.vue";
import Inspeccion from "./../../js/db/Inspeccion.js";
import ModificarEstado from "./components/ModificarEstado.vue";
import EstimarTarea from "./components/EstimarTarea.vue";
import ValorarArreglos from "./components/ValorarArreglos.vue";
import ModificarEstimacionTarea from "./components/ModificarEstimacionTarea";
import TerminarTarea from "./components/TerminarTarea.vue";
import ControlCalidad from "./components/ControlCalidad.vue";
import HistoricoEstadosPopup from "./components/HistoricoEstadosPopup.vue";
import HistoricoEstados from "./components/HistoricoEstados.vue";
import OrdenTrabajo from "./components/OrdenTrabajo.vue";
import TipoInspeccion from "./../../js/db/TipoInspeccion.js";
import Cliente from "./../../js/db/Cliente.js";
import Marca from "./../../js/db/Marca.js";
import Modelo from "./../../js/db/Modelo.js";
import Coche from "./../../js/db/Coche.js";
import Inspector from "./../../js/db/Inspector.js";
import Documento from "./../../js/db/Documento.js";
import Property from "./../../js/db/Property.js";
import validator from "validator";
import DateUtils from "./../../js/DateUtils.js";
import Utils from "./../../js/Utils.js";
import VueTable from "vuejs-spreadsheet";;
import { Container, Draggable } from "vue-smooth-dnd";
import moment from 'moment';
import 'moment/locale/es';
moment.locale('es');

const applyDrag = (arr, dragResult) => {
  const { removedIndex, addedIndex, payload } = dragResult;
  if (removedIndex === null && addedIndex === null) return arr;
  console.log(arr, dragResult);
  //const result = [...arr];
  if (!arr) arr = [];
  var result = arr;

  let itemToAdd = payload;

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0];
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd);
  }

  //return result;
};

export default {
  components: {
    rForm,
    rInput,
    rBadge,
    rFiles,
    rCaracteristica,
    rComprobacion,
    rAutocomplete,
    Container,
    Draggable,
    VueTable,
    ModificarEstado,
    EstimarTarea,
    ValorarArreglos,
    ModificarEstimacionTarea,
    TerminarTarea,
    ControlCalidad,
    HistoricoEstadosPopup,
    HistoricoEstados,
    OrdenTrabajo
  },
  data: function() {
    var self = this;
    return {
      Inspeccion,
      TipoInspeccion,
      Cliente,
      Marca,
      Modelo,
      Coche,
      Inspector,
      Documento,
      Property,
      readonly: !this.editable,
      inspeccionInicial: null,
      inspeccion: {},
      configuraciones: [], 
      popupOrdenTallerOpened: false,
      popupSolicitarGarantiaOpened: false,
      popupResumenGastos: false,
      popupConcatenarDocumentosOpened: false,
      formDocAportadaReadonly: true,
      validator,
      DateUtils,
      Utils,
      moment,
      popupHistoricoControlCalidadOpened: false,
      ubicaciones: [],
      localizaciones: [],
      talleres: [],
      cliente: undefined,
    };
  },
  watch: {
    cliente: {
      handler(nuevoCliente) {
        const self = this;
        // Buscamos las ubicaciones por cliente llamando a Cliente.clienteContactos(params) y poniendo como itemId el id del cliente
        if (!nuevoCliente || !nuevoCliente.id) {
          return;
        }
        // buscamos las ubicaciones del cliente si no las tenemos
        if (!nuevoCliente.ubicaciones || nuevoCliente.ubicaciones.length == 0) {
          Cliente.getUbicaciones({itemId: nuevoCliente.id}).then(ubicaciones => {
            nuevoCliente.ubicaciones = ubicaciones;

            self.ubicaciones = self.buscarUbicaciones(nuevoCliente);
            self.talleres = self.buscarTalleres(nuevoCliente);
            self.localizaciones = self.buscarLocalizaciones(nuevoCliente);
          }).catch(e => {
            console.error("Error buscando ubicaciones del cliente", e);
          });
        } else {
          // si ya tenemos las ubicaciones las buscamos directamente
          self.ubicaciones = self.buscarUbicaciones(nuevoCliente);
          self.talleres = self.buscarTalleres(nuevoCliente);
          self.localizaciones = self.buscarLocalizaciones(nuevoCliente);
        }
      },
      immediate: true // Para que se ejecute al cargar el formulario
    },
  },
  props: {
    id: {
      type: String
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
  },
  beforeDestroy() {},
  methods: {buscarUbicaciones: function(cliente) {
      var self = this;
      // vamos a devolver todas las ubicaciones de tipo UBICACION
      return cliente.ubicaciones && cliente.ubicaciones.length > 0 ? 
        cliente.ubicaciones.filter(u => u.tipo == 'UBICACION').map(u => ({nombre: u.nombre, valor: u.nombre})) : 
        [];
    },
    buscarTalleres: function(cliente) {
      var self = this;
      // vamos a devolver todas las ubicaciones de tipo TALLER
      return cliente.ubicaciones && cliente.ubicaciones.length > 0 ? 
        cliente.ubicaciones.filter(u => u.tipo == 'TALLER').map(u => ({nombre: u.nombre, valor: u.nombre})) : 
        [];
    },
    buscarLocalizaciones: function(cliente) {
      var self = this;
      // vamos a devolver todas las ubicaciones de tipo OTRO
      return cliente.ubicaciones && cliente.ubicaciones.length > 0 ? 
        cliente.ubicaciones.filter(u => u.tipo == 'OTRA').map(u => ({nombre: u.nombre, valor: u.nombre})) : 
        [];
    },
    formatFecha(fecha) {
      return moment(fecha).format('DD/MM/YYYY');
    },
    preparadoParaEstimar: function() {
      const self = this;
      return self.$refs.estimarTarea && self.$refs.estimarTarea.preparado(self.inspeccion);
    },
    estimarFecha: function() {
      var self = this;
      self.$refs.estimarTarea.openPopup();
    },
    preparadoParaFinalizarTareaTaller: function() {
      const self = this;
      return self.$refs.terminarTarea && self.$refs.terminarTarea.preparado(self.inspeccion);
    },
    modificarFechaEstimada: function() {
      var self = this;
      self.$refs.modificarEstimacionTarea.openPopup();
    },
    terminarTarea: function() {
      var self = this,
        item = self.inspeccion,
        campos = (item && item.situacion && item.situacion.jsoncamposPersonalizadosDepartamento)
          ? JSON.parse(item.situacion.jsoncamposPersonalizadosDepartamento) : [];
      self.inspeccion = item;
      self.$set(self.inspeccion.situacion, "camposPersonalizados", {});
      self.$set(self.inspeccion.situacion, "camposPersonalizadosArr", campos);
      self.$refs.terminarTarea.openPopup();
    },
    preparadoParaControlCalidad: function() {
      const self = this;
      return self.$refs.controlCalidad && self.$refs.controlCalidad.preparado(self.inspeccion);
    },
    colorControlCalidad: function() {
      const self = this;
      return self.inspeccion.controlCalidadRealizado ? 'green' : 'orange';
    },
    controlCalidad: function(){
      var self = this;
      self.$refs.controlCalidad.openPopup(self.inspeccion);
    },
    borrarControlCalidad: function(){
      var self = this;
      self.$refs.rform.formData.htmlControlCalidad = undefined;
    },
    forzarCambioEstado: function(){
      var self = this;
      self.$refs.modificarEstado.cambiarEstado();
    },
    enviarATaller: function(){
      var self = this;
      self.$refs.ordenTrabajo.openPopup();
    },
    reloadPage: function(){
      var self = this;
      window.location.reload();
    },
    getHistoricoEstados: function() {
      const self = this;
      return self.$refs.rform && self.$refs.rform.formData && self.$refs.rform.formData.historicoCompleto ? self.$refs.rform.formData.historicoCompleto : [];
    },
    getTextoBadgeEstadoVehiculo: function(index) {  // TODO Extraer datos de badge de lugar comun al de historicoEstados
      var self = this;
      if (index == -1) {
        index = self.getHistoricoEstados().length -1;
      }
      var estado = self.getHistoricoEstados()[index];
      var estadoSiguiente = self.getHistoricoEstados()[index + 1];
      let tiempo = "";
      if(estado.fecha) {
        let fin = !!estadoSiguiente ? new Date(estadoSiguiente.fecha) : new Date();
        let d = Math.trunc((fin - new Date(estado.fecha))/(24*60*60*1000));
        let h = Math.trunc(((fin - new Date(estado.fecha))%(24*60*60*1000))/(60*60*1000));
        let m = Math.trunc((((fin - new Date(estado.fecha))%(24*60*60*1000))%(60*60*1000))/(60*1000));

        tiempo = (d > 0 ? d + "d " :"") + (h > 0 ? h + "h " :"") +  (m > 0 ? m + "min" :"");

        // formato para cuando son muchos días
        if (d > 30) {
          let anyos = Math.trunc(d/365);
          let meses = Math.trunc((d%365)/30);
          let dias = Math.trunc((d%365)%30);

          let textAnyo = anyos == 1 ? " año ": " años ";
          let textMes = meses == 1 ? " mes ": " meses ";
          let textDia = dias == 1 ? " día ": " días" ;

          tiempo = (anyos > 0 ? anyos + textAnyo :"") + (meses > 0 ? meses + textMes :"") +  (dias > 0 ? dias + textDia :"");
        }

        if (!tiempo) {
          tiempo = "0min"
        }

        tiempo = "(" + tiempo + ")";

      }
      if(estado.estado) {
        switch (estado.estado) {
          // case "CITA_SOLICITADA":
          //   return "Cita solicitada";
          case "PLANIFICADO":
            return "Planificado " + tiempo;
          case "VEHICULO_PRESENTE":
            return "Vehículo presente " + tiempo;
          case "PENDIENTE_PARTES":
            return "Pendiente de partes " + tiempo;
          case "PENDIENTE_VALORACION":
            return "Pendiente de valoración " + tiempo;
          case "PENDIENTE_ACEPTACION":
            return "Pendiente de aceptación " + tiempo;
          case "PERITADO":
            return "Peritado " + tiempo;
          case "EN_TALLER":
            return "En taller " + tiempo;
          case "CONTROL_FINAL":
            return "Control final " + tiempo;
          case "FINALIZADO":
            return "Finalizado " + tiempo;
          case "VENDIDO":
            return "Vendido " + tiempo;
          case "CANCELADA":
            return "Cancelada " + tiempo;
          default:
            return estado.estado + " " + tiempo;
        }
      } else {
        return "Sin estado";
      }
          
    },
     getColorBadgeEstadoVehiculo: function(estado) { // TODO Extraer datos de badge de lugar comun al de historicoEstados
      if(estado.estado) {
          console.log(estado);
          if (estado.estado.indexOf("Taller -") == 0) {
            return "orange";
          }
          switch (estado.estado) {
            // case "CITA_SOLICITADA":
            //   return "yellow";
            case "CITA_PROGRAMADA":
              return "green";
            case "REVISADO":
              return "blue";
            case "EN_TALLER":
              return "orange";
            case "TERMINADO_TALLER":
              return "pink";
            case "VENDIDO":
              return "purple";
          }
      } else {
          return "gray";
        }
    },
    getColorBadgeCalificacion: function(calificacion) {
      switch (calificacion) {
        case "BUENO":
        case "EXCELENTE":
          return "green";
        case "DESFAVORABLE":
        case "DEFECTOS_CORREGIDOS":
          return "red";
        default:
          return "gray";
      }
    },
    cambiaEstadoCoche() {
      var self = this;
      var app = self.$f7;
      if (self.$refs.rform && self.$refs.rformCambioEstado && self.$refs.rformCambioEstado.formData && self.$refs.rformCambioEstado.formData.estado) {
        app.preloader.show();
        var estado = self.$refs.rformCambioEstado.formData.estado.id;
        var observaciones = self.$refs.rformCambioEstado.formData.observaciones;
        Inspeccion.cambiaEstadoVehiculo({id: self.$refs.rform.formData.id, data: {observaciones, estado}}).then(function(res) {
          self.$set(self.$refs.rform.formData.lineaPedido.coche, 'estado', res.dto.lineaPedido.coche.estado);
          self.$set(self.$refs.rform.formData.lineaPedido.coche, 'historico', res.dto.lineaPedido.coche.historico);
          app.dialog.alert("Se ha realizado el cambio de estado del vehículo.");
          self.$refs.popupCambiaEstadoOpened.close()
        }).catch(function(error) {
          if (error.message) {
            app.dialog.alert(error.message);
          } else {
            app.dialog.alert(error);
          }
          self.$refs.popupCambiaEstadoOpened.close()
        }).finally(_ => app.preloader.hide());
      } else {
        app.dialog.alert("No hay estado que cambiar.");
      }
    },
    cambioEstadoVehiculo(estado){
      var self = this;
      if(!estado.id || estado.id == '') {
        self.$set(self.$refs.rformCambioEstado.formData, "estado", null);
      } else {
        self.$set(self.$refs.rformCambioEstado.formData, "estado", estado);
      }
    },
    cancelarEdicion(){
      var self = this;
      self.$refs.rform.formData = Object.assign({},self.inspeccionInicial);
      self.readonly = true;
    },
    reloadFirmas: function(firmasDisponibles){
      console.log("reload");
      var self = this,
        firmaMecanico = self.$refs.firmaMecanico,
        firmaTecnico = self.$refs.firmaTecnico,
        firmaMaestroTaller = self.$refs.firmaMaestroTaller,
        firmaResponsableVO = self.$refs.firmaResponsableVO,
        firmaAsesorServicio = self.$refs.firmaAsesorServicio,
        firmaResponsableVehiculosOcasion = self.$refs.firmaResponsableVehiculosOcasion,
        firmasDefecto = [firmaMecanico, firmaTecnico, firmaMaestroTaller, firmaResponsableVO, firmaAsesorServicio,firmaResponsableVehiculosOcasion];
      firmasDefecto.forEach(firmaRef => {
        if (firmaRef) {
          firmaRef.reload(firmasDisponibles);
          if(firmaRef.selected && firmaRef.selected.id && !firmaRef.items.some(item => item.id == firmaRef.selected.id)){
            firmaRef.setValue(null);
          }
        }
      });
    },
    loadItem(item) {
      const self = this;

      // vamos a setear el cliente en self.cliente para que se dispare el watcher
      if (item.cliente && item.cliente.id) {
        self.cliente = item.cliente;
        // buscamos las ubicaciones del cliente si no las tenemos
        if (!self.cliente.ubicaciones || self.cliente.ubicaciones.length == 0) {
          Cliente.getUbicaciones({itemId: self.cliente.id}).then(ubicaciones => {
            self.cliente.ubicaciones = ubicaciones;
          }).catch(e => {
            console.error("Error buscando ubicaciones del cliente", e);
          });
        }
      } else {
        self.cliente = undefined;
      }

      console.log("loaditem");
      if(!item.valoracionArreglos){
        item.valoracionArreglos = {fotosConNombre:[]};
        self.$set(self.$refs.rform.formData, "valoracionArreglos", item.valoracionArreglos);
      }
      // vamos a crear una variable dentro de las ordenes de taller que se llame documentosOT que será un array de documentos
      if(item.ordenesDeTaller){
        item.ordenesDeTaller.forEach(ot => {
          ot.documentosOT = ot.documento?[ot.documento]:[];
        });
      }
      self.reloadFirmas(item.firmas360.firmasDisponibles);
      self.addDocsOT(item);
    },
    beforeSave: function(data, resolve, reject) {
      var self = this;
      var o = Object.assign({}, data);
      o.clienteId = o.cliente.id;
      delete o.cliente;
      o.inspector = o.inspector? o.inspector.username:null;
      o.lineaPedido.coche.modelo.imagen = Array.isArray(o.lineaPedido.coche.modelo.imagen) ? o.lineaPedido.coche.modelo.imagen[0] : o.lineaPedido.coche.modelo.imagen;
      // Vamos a mirar como nos llegan las fotos con nombre. en el campo documento solo puede haber una foto que será un tipo documento y en el campo documentos habrá una lista.
      if (o.fotosConNombre) {
        o.fotosConNombre.forEach(fcn => {
          if (fcn.documento && Array.isArray(fcn.documento)) {
            fcn.documento = fcn.documento[0];
          }
          if (fcn.documentos && !Array.isArray(fcn.documentos)) {
            fcn.documentos = [fcn.documentos];
          }
        });
      }
      resolve(o);
    },
    getDocumentsChecked: function(docs) {
      const self = this;
      return docs.filter(d => d.selected);
    },
    onSwitchDocumentsChecks: function (docs,$event) {
      var self = this;
      if (!$event || !$event.target) {
        return;
      }
      docs.forEach(d => {
        d.selected = !$event.target.checked;
        self.documentSelected(d);
      })
      // self.clearAll();
    },
    searchCoche: function(e) {
      var self = this;
      if (
        !self.$refs.rform.formData.cliente ||
        !self.$refs.rform.formData.cliente.id
      )
        return;
      var aux = e.target.name.split(".");
      var prop = aux.pop();
      var val = e.target.value;
      aux.pop();
      var linea = aux.pop();
      var params = { clienteId: self.$refs.rform.formData.cliente.id };
      params[prop] = val;
      Coche.getFirstWithInspectionType(params).then(function(res) {
        self.$set(
          self.$refs.rform.formData["lineas"][linea],
          "tipoInspeccion",
          res.dto.tipoInspeccion
        );
        if (res.dto.matricula) {
          delete res.dto.tipoInspeccion;
          self.$refs.rform.formData["lineas"][linea]["coche"] = res.dto;
        }
      });
    },
    onSave: function(res) {
      var self = this;
      var app = self.$f7;
      var router = self.$f7router;
      self.$refs.rform.formData = res;
      self.readonly = true;
      app.toast
        .create({
          text: self.$t("inspecciones.inspeccion_form.inspeccion_guardada"),
          position: "center",
          closeTimeout: 2000,
          icon: '<i class="f7-icons">checkmark_alt</i>'
        })
        .open();

    },
    getEstadoBadge: function(estado) {
      switch (estado) {
        case "PLANIFICADO":
          var texto = "Planificado";
          var color = "blue";
          break;
        case "VEHICULO_PRESENTE":
          var texto = "Vehículo presente";
          var color = "lime";
          break;
        case "PENDIENTE_PARTES":
          var texto = "Pendiente de partes";
          var color = "yellow";
          break;
        case "PENDIENTE_VALORACION":
          var texto = "Pendiente de valoración";
          var color = "orange";
          break;
        case "PENDIENTE_ACEPTACION":
          var texto = "Pendiente de aceptación";
          var color = "orange";
          break;
        case "PERITADO":
          var texto = "Peritado";
          var color = "blue";
          break;
        case "EN_TALLER":
          var texto = "En Taller";
          var color = "orange";
          break;
        case "CONTROL_FINAL":
          var texto = "Control final";
          var color = "orange";
          break;
        case "PREPARADO":
          var texto = "Preparado";
          var color = "green";
          break;
        case "VENDIDO":
          var texto = "Vendido";
          var color = "purple";
          break;
        case "FINALIZADO":
          var texto = "Finalizado";
          var color = "gray";
          break;
        case "CANCELADA":
          var texto = "Cancelado";
          var color = "red";
          break;
        default:
          var texto = estado;
          var color = "gray";
      }
      return `<span class="badge color-` + color + `">` + texto + `</span>`;
    },
    getTipoInspeccionBadge: function(tipoInspeccion) {
      switch (tipoInspeccion) {
        case "CERTIFICACION_1":
          var texto = "1ª Certificación";
          var color = "blue";
          break;
        case "CERTIFICACION_2":
          var texto = "2ª Certificación";
          var color = "orange";
          break;
        case "CERTIFICACION_3":
          var texto = "3ª Certificación";
          var color = "purple";
          break;
        case "CERTIFICACION_4":
          var texto = "4ª Certificación";
          var color = "teal";
          break;
        case "CERTIFICACION_M":
          var texto = "Protocolo de Entrega";
          var color = "teal";
          break;
        default:
          var texto = tipoInspeccion;
          var color = "gray";
      }
      return `<span class="badge color-` + color + `">` + texto + `</span>`;
    },
    getTipoConflictoBadge: function(tipoConflicto) {
      switch (tipoConflicto) {
        case "RESUELTO_CAMPO":
          var texto = "Resuelto en campo";
          var color = "green";
          break;
        case "ENVIADO_MARCA":
          var texto = "Enviado marca";
          var color = "orange";
          break;
        default:
          var texto = tipoConflicto;
          var color = "gray";
      }
      return `<span class="badge color-` + color + `">` + texto + `</span>`;
    },
    getConflictosBadge: function(conflictos) {
      if (conflictos == null || conflictos == undefined || conflictos.length == 0) {
        var texto = "No";
        var color = "green";
      } else {
        var texto = "Si (" + conflictos.length + ")";
        var color = "red";
      }
      return `<span class="badge color-` + color + `">` + texto + `</span>`;
    },
    getSiNoBadge: function(bool) {
      if (bool) {
        var texto = "Si";
        var color = "green";
      } else {
        var texto = "No";
        var color = "red";
      }
      return `<span class="badge color-` + color + `">` + texto + `</span>`;
    },
    getResolucionBadge: function(resolucion) {
      switch (resolucion) {
        case "OK":
          var texto = "Positiva";
          var color = "green";
          break;
        case "KO":
          var texto = "Negativa";
          var color = "red";
          break;
        default:
          var texto = "Sin resolver";
          var color = "gray";
      }
      return `<span class="badge color-` + color + `">` + texto + `</span>`;
    },
    getCalificacionBadge: function(certificacion) {
      if(certificacion.lineaPedido && certificacion.lineaPedido.tipoInspeccion == "CERTIFICACION_M"){
        var realizada = !!certificacion.calificacion;
        var texto = realizada ? "Realizado" : "Sin realizar";
        var color = realizada ? "green" : "gray";
      } else {
        switch (certificacion.calificacion) {
          case "EXCELENTE":
            var texto = "Excelente";
            var color = "green";
            break;
          case "BUENO":
            var texto = "Buena";
            var color = "lime";
            break;
          case "DESFAVORABLE":
            var texto = "Desfavorable";
            var color = "red";
            break;
          case "EN_CONFLICTO":
            var texto = "Pendiente";
            var color = "orange";
            break;
          case "JUSTIFICADA":
            var texto = "Justificada";
            var color = "orange";
            break;
          case "DEFECTOS_CORREGIDOS":
            var texto = "Resuelto de 2as";
            var color = "black";
            break;
          default:
            var texto = "Sin realizar";
            var color = "gray";
        }
      }
      return `<span class="badge color-` + color + `">` + texto + `</span>`;
    },
    getConfiguraciones: function () {
      var self = this;
      var app = self.$f7;
      console.log("cliente", self.$refs.rform.formData.cliente);
      // Miramos a ver si hay cliente asociado a la inspección
      if (self.$refs.rform && self.$refs.rform.formData && self.$refs.rform.formData.cliente) {
        // Si hay cliente, miramos a ver si aún no tenemos sus configuraciones cargadas y las cargamos
        if(!self.$refs.rform.formData.configuraciones) {
          Cliente.getConfiguraciones({data: {idCliente: self.$refs.rform.formData.cliente.id}}).then(function(res) {
            self.$set(self.$refs.rform.formData, 'configuraciones', res); 
          }).catch(function(error) {
            if (error.message) {
              app.dialog.alert(error.message);
            } else {
              app.dialog.alert(error);
            }
          });
        }
      }
    },
    comprobarConfiguracion: function (configuracion,valor) {
      if(valor === undefined) {
        return "true";
      }
      var self = this;
      var app = self.$f7;
      // Si no le pasamos una configuración para buscar, devolvemos false
      if (!configuracion) {
        return false;
      }
      // Miramos a ver si hay cliente asociado a la inspección
      if (self.$refs.rform && self.$refs.rform.formData && self.$refs.rform.formData.cliente) {
              console.log("cliente", self.$refs.rform.formData.cliente);

        // Si hay cliente, miramos a ver si aún no tenemos sus configuraciones cargadas y las cargamos
        if(!self.$refs.rform.formData.configuraciones) {
          Cliente.getConfiguraciones({data: {idCliente: self.$refs.rform.formData.cliente.id}}).then(function(res) {
            self.$set(self.$refs.rform.formData, 'configuraciones', res); 
            self.configuraciones = res;
          }).catch(function(error) {
            if (error.message) {
              app.dialog.alert(error.message);
            } else {
              app.dialog.alert(error);
            }
          });
        }
        // en este punto tenemos que tener las configuraciones del cliente de la inspección cargadas en el formulario.
        if(self.$refs.rform.formData.configuraciones && self.$refs.rform.formData.configuraciones.find(c => c.tipoConfiguracion == configuracion && c.valor == valor)) {
          return true;
        } else {
          return false;
        }
          
      } else {
        return false;
      }
    },

    getValorConfiguracion: function (configuracion) {
      var self = this;
      var app = self.$f7;
      
      // Si no existe la configuración, devolvemos cadena vacía
      if (!configuracion) {
        return "";
      }
      // Miramos a ver si hay cliente asociado a la inspección
      if (self.$refs.rform && self.$refs.rform.formData && self.$refs.rform.formData.cliente) {
        // Si hay cliente, miramos a ver si aún no tenemos sus configuraciones cargadas y las cargamos
        if(!self.$refs.rform.formData.configuraciones) {
          Cliente.getConfiguraciones({data: {idCliente: self.$refs.rform.formData.cliente.id}}).then(function(res) {
            self.$set(self.$refs.rform.formData, 'configuraciones', res); 
            self.configuraciones = res;
          }).catch(function(error) {
            if (error.message) {
              app.dialog.alert(error.message);
            } else {
              app.dialog.alert(error);
            }
          });
        }
        // en este punto tenemos que tener las configuraciones del cliente de la inspección cargadas en el formulario.
        if(self.$refs.rform.formData.configuraciones && self.$refs.rform.formData.configuraciones.find(c => c.tipoConfiguracion == configuracion)) {
          return self.$refs.rform.formData.configuraciones.find(c => c.tipoConfiguracion == configuracion).valor;
        } else {
          return "";
        }
          
      } else {
        return "";
      }
    },
    comprobarNombreCliente: function (nombre) {
      return false;
      var self = this;
      var app = self.$f7;
      // Le pasamos en nombre del cliente. Ej) nombre: "Cars&Cars"
      if (!nombre) {
        return false;
      }
      // Miramos a ver si hay cliente asociado a la inspección
      if(self.$refs.rform.formData.cliente && self.$refs.rform.formData.cliente.nombre.toUpperCase() == nombre.toUpperCase()) {
        return true;
      } else {
        return false;
      }
    },
    generarOrdenTaller: function (formulario = 'rformOrdenTaller') {
      var self = this;
      var app = self.$f7;
      // Miramos a ver si hay destinatarios en la orden de taller
      if (self.$refs[formulario] && self.$refs[formulario].formData && self.$refs[formulario].formData.ordenTaller) {
        app.preloader.show();
        if(!self.$refs[formulario].formData.ordenTaller.camposCabecera) {
          self.$refs[formulario].formData.ordenTaller.camposCabecera = {};
        }
        Inspeccion.enviarOrdenTaller({idInspeccion: self.$refs.rform.formData.id,data: self.$refs[formulario].formData.ordenTaller}).then(function(res) {
          // Metemos la nueva orden de taller en la lista de ordenes de taller de la inspección.
          self.addDocsOT(res.dto);
          self.$set(self.$refs.rform, 'formData', res.dto); 
          if(self.$refs[formulario].formData.ordenTaller.destinatarios.toString().replaceAll(',','').length > 0) {
            app.dialog.alert("Orden de taller enviada a los destinatarios indicados.");
          } else {
            app.dialog.alert("Orden de taller guardada <b>pero no enviada</b>.");
          }
          if(formulario == 'rformOrdenTaller') {self.$refs.popupOrdenTaller.close();}
          else {self.$refs.popupResumenGastos.close();}
        }).catch(function(error) {
          if (error.message) {
            app.dialog.alert(error.message);
          } else {
            app.dialog.alert(error);
          }
          if(formulario == 'rformOrdenTaller') {self.$refs.popupOrdenTaller.close();}
          else {self.$refs.popupResumenGastos.close();}
        }).finally(_ => app.preloader.hide());
      } else {
        app.dialog.alert("No hay orden de taller que enviar.");
      }
    },
    solicitarGarantia: function () {
      var self = this;
      var app = self.$f7;
      if (self.$refs.rformSolicitarGarantia && self.$refs.rformSolicitarGarantia.formData) {
        app.preloader.show();
        
        Inspeccion.enviarSolicitudGarantia({idInspeccion: self.$refs.rform.formData.id,data: self.$refs.rformSolicitarGarantia.formData}).then(function(res) {
          self.$set(self.$refs.rform, 'formData', res.dto); 
          app.dialog.alert("Solicitud de garantía mecánica enviada.");
        }).catch(function(error) {
          if (error.message) {
            app.dialog.alert(error.message);
          } else {
            app.dialog.alert(error);
          }
        }).finally(_ => app.preloader.hide());
        self.$refs.popupSolicitarGarantia.close();
      } else {
        app.dialog.alert("No hay solicitud que enviar.");
      }
    },

    buscarCaracteristica: function(caracteristicas,codigo) {
      var self = this;
      var app = self.$f7;
      // Buscamos la característica KILOMETROS en el arbol de características del formData para asignarla a la solicitud
      if(caracteristicas.length > 0) {
        var caracteristica;
        for(let i = 0;i < caracteristicas.length; i++){
          caracteristica = caracteristicas[i];
          if(!caracteristica.hijas) {
            if(caracteristica.codigo == codigo) {return caracteristica.valor;}
          } else {
            let resultado = self.buscarCaracteristica(caracteristica.hijas, codigo);
            if(resultado) {return resultado;}
          }
        }
        // caracteristicas.forEach(caracteristica => {
        //   if(!caracteristica.hijas) {
        //     if(caracteristica.codigo == codigo) {return caracteristica.valor;}
        //   } else {
        //     let resultado = self.buscarCaracteristica(caracteristica.hijas, codigo);
        //     if(resultado) {return resultado;}
        //   }
        // });
      }
    },
    prepareSolicitarGarantia: function () {
      var self = this;
      var app = self.$f7;
      if(self.$refs.rform && self.$refs.rform.formData) {
        let solicitud = {
          idInspeccion: self.$refs.rform.formData.id,
          codigoInspeccion: self.$refs.rform.formData.codigo,
          coche: self.$refs.rform.formData.lineaPedido.coche
        };
        // Buscamos la característica KILOMETROS en el arbol de características del formData para asignarla a la solicitud
        solicitud.kilometros = self.buscarCaracteristica(self.$refs.rform.formData.caracteristicas, 'KILOMETROS');
        if(self.$refs.rform.formData.solicitudGarantia) {
          solicitud.id = self.$refs.rform.formData.solicitudGarantia.id;
          solicitud.dniComprador = self.$refs.rform.formData.solicitudGarantia.dniComprador;
          solicitud.nombreComprador = self.$refs.rform.formData.solicitudGarantia.nombreComprador;
          solicitud.direccionComprador = self.$refs.rform.formData.solicitudGarantia.direccionComprador;
          solicitud.telefonoComprador = self.$refs.rform.formData.solicitudGarantia.telefonoComprador;
          solicitud.emailComprador = self.$refs.rform.formData.solicitudGarantia.emailComprador;
          solicitud.fechaIniGarantia = self.$refs.rform.formData.solicitudGarantia.fechaIniGarantia;
          solicitud.fechaFinGarantia = self.$refs.rform.formData.solicitudGarantia.fechaFinGarantia;
        } else {
          solicitud.nombreComprador = "";
          solicitud.dniComprador = "";
          solicitud.direccionComprador = {};
          solicitud.telefonoComprador = "";
          solicitud.emailComprador = "";
          solicitud.fechaIniGarantia = null;
          solicitud.fechaFinGarantia = null;
        }
        self.$set(self.$refs.rformSolicitarGarantia, 'formData', solicitud); 
      }
    },
    prepareResumenGastos: function () {
      var self = this;
      var app = self.$f7;
      var nuevaOT = {};
      // Si no hay una orden de taller, la creamos
      if(self.$refs.rform && self.$refs.rform.formData && (!self.$refs.rform.formData.ordenesDeTaller || self.$refs.rform.formData.ordenesDeTaller.length == 0)) {
        var camposCabecera = [];
        if(self.$refs.rform.formData.configuraciones && self.$refs.rform.formData.configuraciones.find(c => c.tipoConfiguracion == 'ORDEN_TALLER_CABECERA')) {
          // vamos a recuperar el nombre de la property que contiene las cabeceras
          var nombreProperty = self.$refs.rform.formData.configuraciones.find(c => c.tipoConfiguracion == 'ORDEN_TALLER_CABECERA');
          var configuracionCabecera = [];
          if( nombreProperty ) {
            Property.getList({filter: {nombre: nombreProperty.valor} }).then(function(res) {
              configuracionCabecera = res.list[0];
              camposCabecera = JSON.parse(configuracionCabecera.valor);
              nuevaOT = {
                idInspeccion: self.$refs.rform.formData.id,
                camposCabeceraLista: camposCabecera,
                camposCabecera: null,
                camposExtraLista: camposExtra,
                trabajos: [],
                destinatarios: [""],
                inspeccion: self.$refs.rform.formData
              };

              // Crearemos 27 trabajos de carrocería vacíos
              for(var i = 0; i < 27; i++) {
                nuevaOT.trabajos.push({
                  tipoTrabajo: 'CARROCERIA',
                  nombre: '',
                  camposPersonalizados: {pintar: '',accion: ''},
                  realizado: false
                });
              }


              // Crearemos 27 trabajos de mecánica vacíos
              for(var i = 0; i < 27; i++) {
                nuevaOT.trabajos.push({
                  tipoTrabajo: 'MECANICO',
                  nombre: '',
                  camposPersonalizados: {accion: ''},
                  realizado: false
                });
              }

              self.$set(self.$refs.rformResumenGastos.formData, 'trabajosCarroceria', nuevaOT.trabajos.filter(t => t.tipoTrabajo == 'CARROCERIA'));
              self.$set(self.$refs.rformResumenGastos.formData, 'trabajosMecanicos', nuevaOT.trabajos.filter(t => t.tipoTrabajo == 'MECANICO'));

              // vamos a recuperar el nombre de la property que contiene los campos extra en el formato
              let camposExtra = [];
              if(self.$refs.rform.formData.configuraciones && self.$refs.rform.formData.configuraciones.find(c => c.tipoConfiguracion == 'ORDEN_TALLER_FORMATO')) {
                var configuracionFormato = [];
                var nombreFormato = self.$refs.rform.formData.configuraciones.find(c => c.tipoConfiguracion == 'ORDEN_TALLER_FORMATO');
                if( nombreFormato ) {
                  Property.getList({filter: {nombre: 'OT_FORMATOS'} }).then(function(res) {
                    configuracionFormato = res.list[0];
                    let formatos = JSON.parse(configuracionFormato.valor);
                    let formato = formatos.find(f => f.nombre == nombreFormato.valor);
                    camposExtra = formato?formato.camposExtra:[];
                    nuevaOT.camposExtraLista = camposExtra;
                    nuevaOT.camposExtra = camposExtra;
                  }).catch(function(error) {
                    if (error.message) {
                      app.dialog.alert(error.message);
                    } else {
                      app.dialog.alert(error);
                    }
                    self.$refs.popupOrdenTaller.close()
                  });
                }

              }
              self.$set(self.$refs.rformResumenGastos.formData, 'ordenTaller', nuevaOT); 
            }).catch(function(error) {
              if (error.message) {
                app.dialog.alert(error.message);
              } else {
                app.dialog.alert(error);
              }
              self.$refs.popupResumenGastos.close()
            });
          }
        }
      } else {
        nuevaOT = self.$refs.rform.formData.ordenesDeTaller[0];
        self.$set(self.$refs.rformResumenGastos.formData, 'ordenTaller', nuevaOT); 
        self.$set(self.$refs.rformResumenGastos.formData, 'trabajosCarroceria', nuevaOT.trabajos.filter(t => t.tipoTrabajo == 'CARROCERIA'));
        self.$set(self.$refs.rformResumenGastos.formData, 'trabajosMecanicos', nuevaOT.trabajos.filter(t => t.tipoTrabajo == 'MECANICO'));
      }

    },
    verOrdenTaller: function (event) {
      var self = this;
      var app = self.$f7;

      console.log("verOrdenTaller");

      if(self.$refs.rform.formData.configuraciones && self.$refs.rform.formData.configuraciones.find(c => c.tipoConfiguracion == 'ORDEN_TALLER_CABECERA')) {
        // vamos a recuperar el nombre de la property que contiene las cabeceras
        var nombreProperty = self.$refs.rform.formData.configuraciones.find(c => c.tipoConfiguracion == 'ORDEN_TALLER_CABECERA');
        var configuracionCabecera = [];
        if( nombreProperty ) {
          var p = Promise.resolve();
          p = p.then(_ => new Promise(function(resolve, reject) {
            Property.getList({filter: {nombre: nombreProperty.valor} }).then(function(res) {
              configuracionCabecera = res.list[0];
              var camposCabecera = JSON.parse(configuracionCabecera.valor);
              resolve(camposCabecera);
            }).catch((error) => reject(error));
          }));
          p.then((camposCabecera) => {
            var nuevaOT = self.$refs.rform.formData.ordenesDeTaller[event.target.value];
            nuevaOT.camposCabeceraLista = camposCabecera;
            self.$set(self.$refs.rformOrdenTaller.formData, 'ordenTaller', nuevaOT); 
          }).catch(function(error) {
            if (error.message) {
              app.dialog.alert(error.message);
            } else {
              app.dialog.alert(error);
            }
            self.$refs.popupOrdenTaller.close()
          });
        }

      }

    },
  

    nuevaFotoConNombre: function(fotosConNombre) {
      const self = this;
      const app = self.$f7;
      fotosConNombre.push({nombre: '',visible: false,editable: true});
    },
    eliminarFotoConNombre: function(fotoConNombre, index, fotosConNombre) {
      var self = this;
      var app = self.$f7;
      app.dialog.confirm("¿Está seguro?", "Eliminar foto con nombre ("+fotoConNombre.nombre+")", function() {
        fotoConNombre = null;
        fotosConNombre.splice(index,1);
      });
    },



    valorCaracteristica(codigo, caracteristicas = this.$refs.rform.formData.caracteristicas) {
      var self = this;
      var app = self.$f7;
      let valor =  null;
      caracteristicas.forEach(c => {
        if(c.hijas) {
          valor = self.valorCaracteristica(codigo, c.hijas);
        } else {
          if(c.codigo == codigo) {
            valor = c.valor;
          }
        }
        if(valor) {
          return valor;
        }
      });
      return valor?valor:null;
    },


    onDrop(arr, dropResult) {
      var self = this;
      applyDrag(arr, dropResult);
    },
    documentSelected(documento) {
      var self = this;
      documento.selected = !!!documento.selected;
      var seleccionados = self.$refs.rformConcatenarDocumentos.formData.docs.filter(d=> d.selected == true);
      var noSeleccionados = self.$refs.rformConcatenarDocumentos.formData.docs.filter(d=> d.selected != true);
      var todos = [seleccionados, noSeleccionados].flat();
      self.$set(self.$refs.rformConcatenarDocumentos.formData, 'docs', todos); 
    },
    sortElements() {
      var self = this;
      var app = self.$f7;
      var campo = 'nombre';
      var seleccionados = self.$refs.rformConcatenarDocumentos.formData.docs.filter(d=> d.selected == true)
        .sort((a,b)=> {
          if ( a[campo] < b[campo] ){
            return -1;
          }
          if ( a[campo] > b[campo] ){
            return 1;
          }
          return 0;
        });
      var noSeleccionados = self.$refs.rformConcatenarDocumentos.formData.docs.filter(d=> d.selected != true);
      var todos = [seleccionados, noSeleccionados].flat();
      // self.$refs.rformConcatenarDocumentos.formData.docs = [];
      // self.$refs.rformConcatenarDocumentos.formData.docs = todos;
      self.$set(self.$refs.rformConcatenarDocumentos.formData, 'docs', todos); 
    },
    preparePopUpConcatenarDocumentos: function() {
      var self = this;
      var app = self.$f7;
      if(self.$refs.rform.formData.documentos) {
        self.$refs.rform.formData.documentos.forEach(documento => {
          documento.selected = true;
          documento.color = 'blue';
          documento.origen = 'documentos';
          self.$refs.rformConcatenarDocumentos.formData.docs.push(documento);
        });
      }
      if(self.$refs.rform.formData.informes) {
        self.$refs.rform.formData.informes.forEach(informe => {
          informe.selected = true;
          informe.color = 'blueviolet';
          informe.origen = 'informes';
          self.$refs.rformConcatenarDocumentos.formData.docs.push(informe);
        });
       }
      if(self.$refs.rform.formData.ordenesDeTaller) {
        self.$refs.rform.formData.ordenesDeTaller.forEach(ot => {
          ot.documento.selected = true;
          ot.documento.color = 'black';
          ot.documento.origen = 'ordenTaller';
          self.$refs.rformConcatenarDocumentos.formData.docs.push(ot.documento);
        });
      }
      ;
      // Ordenamos la lista de documentos
      self.$refs.rformConcatenarDocumentos.formData.docs.sort((a,b)=>{
        if (a.nombre > b.nombre) {
          return 1;
        }
        if (a.nombre < b.nombre) {
          return -1;
        }
        // Si no es ni mayor ni menor, es que son iguales
        return 0;
      });
      // Manejador de evento afterCheck
      // self.$refs.rformConcatenarDocumentos.on("afterCheck", self.documentSelected());

    },
    setTipoExport: function(tipo) {
      var self = this;
      var app = self.$f7;
      self.$set(self.$refs.rformConcatenarDocumentos.formData, 'tipoExport', tipo); 
    },
    documentosConcatenados: function() {
      var self = this;
      var app = self.$f7;
      app.preloader.show();
      var params = {
        id: self.$refs.rform.formData.id,
        lineaPedido: self.$refs.rform.formData.lineaPedido,
        tipo: self.$refs.rformConcatenarDocumentos.formData.tipoExport,
        data: self.$refs.rformConcatenarDocumentos.formData.docs.filter(d => d.selected)
      };

      Inspeccion.documentosConcatenados(params).finally(_=>app.preloader.hide());
    },
    beforeAddDoc: function(data, resolve, reject) {
      var self = this;
      var app = self.$f7;
      // self.$refs.rformAddDoc.formData.docsNuevos = [];
      // data.documento.forEach(doc => {
      //   var nuevo = true;
      //   self.$refs.rform.formData.documentos.forEach(docViejo => {
      //     if(docViejo.nombre() == doc.nombre()) {
      //       nuevo = false;
      //     }
      //   });
      //   if(nuevo) {
      //     self.$refs.rformAddDoc.formData.docsNuevos.push(doc);
      //   }
      // });
      if(data) {
        // resolve(self.$refs.rformAddDoc.formData.docsNuevos);
        resolve(data.documento);
      } else {
        reject("No se ha indicado ningún documento para importar.")
      }
    },
    onAddDoc: function (res) {
      var self = this;
      var app = self.$f7;
      app.preloader.show();
      if(!res) {
        reject("No se ha indicado ningún documento para Añadir.")
      }
      var documentos = self.$refs.rform.formData.documentos;
      if (!documentos) {
        documentos = [];
      }
      documentos = documentos.concat(res.documento);
      Inspeccion.addDocumentos({idInspeccion: self.$refs.rform.formData.id ,data: documentos})
        .then(function(res) {
          //self.$refs.rformAddDoc.clear();
          self.$set(self.$refs.rform.formData, 'documentos', res.dto.documentos); 
        }).catch(function(e) {
          if (typeof e == "string") {
            e = {
              message: e
            };
          }
          app.dialog.alert(e.message);
        }).finally(function(e) {
          app.preloader.hide();
        });
    },
    // onAddDocError: function (rform) {
    //   var self = this;
    //   var app = self.$f7;
    //   self.$refs.rformAddDoc.clear();
    //   //self.$refs.rlist.refresh();
    // },

    // loadFiles: function () {
    //   var self = this;
    //   self.$refs.rformAddDoc.saveItem();
    // },
    actualizarDocumentacionAportada: function() {
      var self = this;
      var app = self.$f7;
      app.preloader.show();

      Inspeccion.actualizarDocumentacionAportada({id: self.$refs.rform.formData.id, data: self.$refs.rform.formData})
        .then(function(res) {
          self.formDocAportadaReadonly = true;
          self.$set(self.$refs.rform, 'formData', res.dto); 
        }).catch(function(e) {
          if (typeof e == "string") {
            e = {
              message: e
            };
          }
          app.dialog.alert(e.message);
        }).finally(function(e) {
          app.preloader.hide();
        });
    },










    addDocsOT: function (item) {
      var self = this;
      var app = self.$f7;
      self.inspeccion = item;
      if(self.inspeccion.ordenesDeTallerVisibles) {
        self.inspeccion.documentosOrdenesDeTaller = self.inspeccion.ordenesDeTallerVisibles.filter(ot => ot.documento).map(ot => ot.documento);
        self.$set(self.$refs.rform.formData, 'documentosOrdenesDeTaller', self.inspeccion.documentosOrdenesDeTaller);
      }
    },
    getDefectos: function (){
      var self = this;
      var app = self.$f7;
      var result = [];
      var defectos = new Array();
      return self.getComprobacionesDefectos(self.$refs.rform.formData.comprobaciones);
    },
    addEmail: function() {
      var self = this;
      var arr = self.$refs.rformOrdenTaller.formData.ordenTaller.destinatarios?self.$refs.rformOrdenTaller.formData.ordenTaller.destinatarios : [];
      arr.push("");
      self.$set(self.$refs.rformOrdenTaller.formData.ordenTaller, 'destinatarios', arr);
    },
    addTrabajo: function() { // TODO quitar
      var self = this;
      console.log(self)
      var arr = self.$refs.rformOrdenTaller.formData.ordenTaller.trabajos? self.$refs.rformOrdenTaller.formData.ordenTaller.trabajos : [];
      arr.push({});
      self.$set(self.$refs.rformOrdenTaller.formData.ordenTaller, 'trabajos', arr);
    },
    esTrabajoMecanico: function(trabajo) {
      var self = this;
      if(!trabajo.tipoTrabajo || trabajo.tipoTrabajo == 'MECANICO') {
        trabajo.tipoTrabajo = 'MECANICO';
        return true;
      } else {
        return false;
      }
    },
    getComprobacionesDefectos: function (comprobaciones){
      var self = this;
      var result = [];
      if(comprobaciones) {
        comprobaciones.forEach(comprobacion => {
          if(comprobacion.tipo != "DATA") {
            result.push(self.getComprobacionesDefectos(comprobacion.hijas)); 
          } else if(comprobacion.resultado == "R_3" || comprobacion.resultado == "R_4") {
            result.push(comprobacion); 
          }
        });
      }
      return result.flat();
    },

    peritoVisible: function(){
      var self = this,
          inspeccion = self.inspeccion,
          estado = inspeccion && inspeccion.estado && inspeccion.estado.estado ? inspeccion.estado.estado : "";
      return estado != "PLANIFICADO";
    },
    marcarPeritado: function(){
      var self = this,
          app = self.$f7,
          inspeccion = self.inspeccion,
          data = {estado: 'EN_TALLER'};
      app.preloader.show();
      Inspeccion.cambioEstado(inspeccion.id, data).then(function(res) {
        if (res) {
          app.toast
            .create({
              icon: '<i class="f7-icons">checkmark</i>',
              text: 'Vehículo marcado como recibido',
              position: "center",
              destroyOnClose: true,
              closeTimeout: 2000
            })
            .open();
            self.$refs.rform.formData.lineaPedido.coche.estado.estado = "EN_TALLER";
        }
      }).catch(function(error){
        app.dialog.alert(error.message);
      }).finally( _ => app.preloader.hide());
    },
    valorarArreglos: function(){
      var self = this;
      self.$refs.valorarArreglos.openPopup();
    },
    aceptarValoracion: function() {
      var self = this;
      var app = self.$f7;
      let data = {estado: 'PERITADO', comentario: 'Valoración de daños aceptada'};
      app.preloader.show();
      Inspeccion.cambioEstado(self.$refs.rform.formData.id, data).then(function(res) {
        if (res) {
          app.toast
            .create({
              icon: '<i class="f7-icons">checkmark</i>',
              text: 'Vehículo marcado como recibido',
              position: "center",
              destroyOnClose: true,
              closeTimeout: 2000
            })
            .open();
            self.$refs.rform.formData.lineaPedido.coche.estado.estado = "PERITADO";
        }
      }).catch(function(error){
        app.dialog.alert(error.message);
      }).finally( _ => {app.preloader.hide(),self.reloadPage()});
    },
    rechazarValoracion: function() {
      var self = this;
      var app = self.$f7;
      let mensaje = window.prompt("Motivo del rechazo:", "");
      let data = {estado: 'PENDIENTE_VALORACION', comentario: 'Motivo de rechazo: '+mensaje};
      app.preloader.show();
      Inspeccion.cambioEstado(self.$refs.rform.formData.id, data).then(function(res) {
        if (res) {
          app.toast
            .create({
              icon: '<i class="f7-icons">checkmark</i>',
              text: 'Vehículo marcado como recibido',
              position: "center",
              destroyOnClose: true,
              closeTimeout: 2000
            })
            .open();
            self.$refs.rform.formData.lineaPedido.coche.estado.estado = "PERITADO";
        }
      }).catch(function(error){
        app.dialog.alert(error.message);
      }).finally( _ => {app.preloader.hide(),self.reloadPage()});
    },
    // Devuelve true si el usuario tiene permisos para ver la sección indicada
    permisosVer: function(seccion) {
      var self = this;
      var app = self.$f7;
      let ver = false;
      let user = Utils.getUser();
      if (user.roles.includes("TECNICO")) {
        let clientes = user.clientes.filter(c=>c.id == self.$refs.rform.formData.cliente.id);
        switch (seccion) {
          case 'valoracion':
            ver = clientes.filter(c=>c.departamento == 'CARROCERIA').length > 0;
            break;
          case 'arreglos':
            ver = false;
            break;
          case 'informes':
            ver = false;
            ver = clientes.filter(c=>c.departamento == 'CARROCERIA').length > 0;
            break;
          case 'fotos':
            ver = false;
            ver = clientes.filter(c=>c.departamento == 'CARROCERIA').length > 0;
            break;
          case 'adjuntos':
            ver = false;
            break;
          case 'ordenestaller':
            ver = false;
            break;
          default:
            break;
        }
      } else {
        ver = true;
      }
      return ver;
    },
    estadoPendientePartes: function() {
      var self = this;
      var app = self.$f7;
      var dataRaw = self.$refs.rform.formData;
      var data = {
        estado: 'PENDIENTE_PARTES',
        comentario: self.$t('inspecciones.inspeccion_form.estadoPendientePartes_comentario')
      };
      Inspeccion.forzarcambioEstado(self.inspeccion.id, data).then(function(res) {
        // self.$refs.rform.formData = res.dto;
        self.reloadPage();
      });
    },
    updateCaracteristica: function(codigo,valor) {
      var self = this;
      var app = self.$f7;
      var caracteristicas = self.$refs.rform.formData.caracteristicas;
      var caracteristica = self.getCaracteristica(caracteristicas, codigo);
      if(caracteristica) {
        self.$set(caracteristica, 'valor', valor);
      }
      if(self.$refs.rform.formData.valoracionArreglos && self.$refs.rform.formData.valoracionArreglos.caracteristicas) {
        caracteristica = self.getCaracteristica(self.$refs.rform.formData.valoracionArreglos.caracteristicas, codigo);
        if(caracteristica) {
          self.$set(caracteristica, 'valor', valor);
        }
      }
      if(self.$refs.rform.formData.controlCalidad && self.$refs.rform.formData.controlCalidad.caracteristicas) {
        caracteristica = self.getCaracteristica(self.$refs.rform.formData.controlCalidad.caracteristicas, codigo);
        if(caracteristica) {
          self.$set(caracteristica, 'valor', valor);
        }
      }
    },
    // Busca la característica de entre las del árbol, que tenga el código indicado por código
    getCaracteristica(caracteristicas,codigo) {
      if(!caracteristicas) {return null;}
      var self = this;
      var app = self.$f7;
      // buscamos la caracteristica con código igual a código
      let caracteristica = caracteristicas.find(c => c.codigo == codigo);
      if(!caracteristica) {
        caracteristicas.forEach(c => {
          if(!caracteristica && c.hijas) {
            caracteristica = self.getCaracteristica(c.hijas, codigo);
          }
        });
      }
      return caracteristica;
    },

  },
  mounted: function() {
    var self = this;
    var $ = self.$$;
    var $el = $(self.$el);
    var app = self.$f7;
    console.log("insp", self.inspeccion);

  }
};
</script>